export default {
  // -----------   Common   -----------

  common10n: '10n',
  commonAll: 'Всички',
  commonViewAll: 'Виж всички',
  commonXtoY: '@@1 до @@2',
  commontoY: 'до @@1',
  commonOver: 'Над',
  commonOverX: 'Над @@1',
  commonUpTo: 'До',
  commonDate: 'Дата',
  commonSearch: 'Търси',
  commonShowAll: 'Виж всички',
  commonDocuments: 'Документи',
  commonClose: 'Затвори',
  commonFavourites: 'Любими',
  commonRemove: 'Премахни',
  commonDefault: 'По подразбиране',
  commonLastPrice: 'Последна цена',
  commonLastPriceShort: 'Последна',
  commonChange: 'Промяна',
  commonIndustry: 'Сектор / Индустрия',
  commonNext: 'Продължи',
  commonConfirm: 'Потвърди',
  commonOK: 'Ок',
  commonSave: 'Запази',
  commonLoadMore: 'Зареди повече',
  commonDetails: 'Детайли',
  commonButtonsTryAgain: 'Опитай отново',
  commonButtonContactSupport: 'Връзка с нас',
  commonSupport: 'Помощ',
  commonLogout: 'Изход',
  commonPopupTitleInformation: 'Информация',
  commonReturnToHomePage: 'Към главна страница',
  commonYear: 'Година',
  commonNoInternetConnection: 'Няма интернет връзка',
  commonPoorInternetConnection: 'Лоша интернет връзка',
  commonOrderSummary: 'Детайли по поръчката',
  commonSymbol: 'Символ',
  commonAsset: 'Актив',
  commonLearnMoreAt: 'Научи повече тук.',
  commonLearnMore: 'Научи повече',
  commonConnectionIssue: 'Проблеми с връзката',
  commonStartDate: 'Начало',
  commonEndDate: 'Край',
  commonPoweredBy: 'Powered by',
  commonContactUs: 'Връзка с нас',
  commonCalendarDay: '@@1 ден',
  commonCalendarDays: '@@1 дни',
  commonPosition: 'Позиция',
  commonPlayer: 'Играч',
  commonPrize: 'Награда:\u00A0BGN\u00A0',
  commonGood: 'Добре',
  commonOr: 'или',
  commonSee: 'Виж',
  commonFor: 'за',

  // portals - N/A
  commonPortalsFundPortal: 'Fund Portal',
  commonFundPortalMoveFunds: 'Move funds from your Fund Portal account',

  // Request error messages
  requestErrorOver400: 'Възникна грешка',
  requestErrorOver500: 'Опа. Нещо се счупи!',
  requestErrorTryAgain: 'Нещо се обърка. Моля, пробвайте отново.',

  // Change Password
  commonChangePasswordNewPassword: 'Нова парола',
  commonChangePasswordCurrentPassword: 'Настояща парола',

  // common preloading messages
  commonMessageLoading: 'Зареждане @@1...',
  commonMessageConnecting: 'Свързване ...',
  commonMessageRefreshing: 'Презареждане ...',
  commonMessageSwitchingStockTrading: 'Прехвърляне към търговия с акции',
  commonMessageConnectionTimedOut: 'Сесията изтече. @@1Моля проверете интернет връзката си и опитайте отново ...',
  commonMessageNoData: 'Липсват данни',
  commonMessageConnectingMerchant: 'Свързване със сървъра...',

  // orders
  commonOrderSideButtonBuy: 'Купи',
  commonOrderSideButtonSell: 'Продай',
  commonOrderSideButtonKeepIt: 'Не, запази',
  commonOrderSideButtonKeepIt2: 'Не, запазете',
  commonOrderSideButtonProceed: 'Да, продължи',
  commonOrderSideButtonProceed2: 'Да, продължете',

  // order status map
  commonOrderStatusPending: 'Чакаща',
  commonOrderStatusPendingApproval: 'Чакаща одобрение',
  commonOrderStatusCompleted: 'Завършена',
  commonOrderStatusUnknown: 'Неизвестен статус',
  commonOrderStatusAccepted: 'Приета',
  commonOrderStatusCanceled: 'Отменена',
  commonOrderStatusSubmitted: 'Изпратена',
  commonOrderStatusQueued: 'Чакаща',
  commonOrderStatusRejected: 'Отказана',
  commonOrderStatusInProgress: 'Изпълнява се ',
  commonOrderStatusFilterFilled: 'Изпълнена',
  commonOrderStatusFilterPartiallyFilled: 'Частично изпълнена',
  commonOrderStatusFilterPartiallyRejected: 'Частично отказана',
  commonOrderStatusFilterTitle: 'Статус',
  commonOrderStatusFilterAll: 'Всички',
  commonOrderStatusFilterExpired: 'Изтекла',
  commonOrderStatusFilterCancelled: 'Отменена',
  commonOrderStatusUndefined: 'Неопределен статус',

  // order time in force map
  commonOrderTimeInForceDay: 'Валидна за деня',
  commonOrderTimeInForceOnOpen: 'Отварящ аукцион',
  commonOrderTimeInForceIOC: 'Изпълни или отмени',
  commonOrderTimeInForceExtDay: 'Удължени часове',
  commonOrderTimeInForceOnClose: 'Закриващ аукцион',
  commonOrderTimeInForceExtendedHours: 'Удължени часове',

  // watchlist
  commonWatchlist: 'Акции на фокус ',
  commonWatchlistTitle: 'Добре дошли@@1',
  commonWatchlistChartLoading: 'Зареждане',
  commonWatchlistChartNoData: 'Няма данни',
  commonWatchlistChartNA: 'n/a',
  commonWatchlistRetry: 'Опитай отново',
  commonWatchlistCongratulations: 'Поздравления',
  commonWatchlistYourAccountHasBeenVerified: 'Профилът Ви беше верифициран',
  symbolDetailsAddToWatchlist: 'Добави в любими',
  symbolDetailsAddedToWatchlist: 'Добавен в любими',
  commonSelectWatchlist: 'Избери Списък с Акции на фокус',
  commonSelectReport: 'Избери отчет',
  commonSymbolAddedToWatchlistMsg: '@@1 е добавен към списъка Ви с любими символи.',
  commonSymbolRemovedToWatchlistMsg: '@@1 беше премахнат от списъка Ви с любими символи.',
  commonWatchlistNoStocks: 'Няма добавени символи към списъка Ви с любими',
  commonWatchlistFavoutesLimit: 'Добавете до 15 символа към списъка Ви с любими',
  commonWatchlistFavoutesLimitReached: 'Списъкът Ви с любими символи е вече пълен  - 15 от максимален брой 15.',
  commonQuantityXAveragePrice: 'Брой x Средна цена',
  commonUnrealizedProfit: 'Текуща печалба',
  commonMarketValue: 'Пазарна стойност',

  // watchlist headers my account -> my stocks
  headerMyAccountMyStockSymbolName: 'Символ / Компания',
  headerMyAccountMyStockQuantity: 'Брой',
  headerMyAccountMyStockPurchasePrice: 'Покупна цена',
  headerMyAccountMyStockMarketPrice: 'Пазарна цена',
  headerMyAccountMyStockUnrealizedProfit: 'Текуща печалба',
  headerMyAccountMyStockUnrealizedProfitPercent: 'Текуща печалба %',
  headerMyAccountMyStockButtons: 'Бутони',

  // watchlist headers my account -> pending orders
  headerMyAccountPendingOrderSymbolName: 'Символ / Компания',
  headerMyAccountPendingOrderDatePlaced: 'Дата на поръчка',
  headerMyAccountPendingOrderType: 'Тип',
  headerMyAccountPendingOrderQuantity: 'Брой',
  headerMyAccountPendingOrderSetPrice: 'Желана цена',
  headerMyAccountPendingOrderExpiryDate: 'Крайна дата',
  headerMyAccountPendingOrderExpiryDate2: 'Валидност',
  headerMyAccountPendingOrderButtons: 'Бутони',

  // verification
  commonVerificationVerifyingIdentity: 'Верифициране на профила',
  commonVerificationYourDocumentsAreUnderReview: 'Разглеждаме Вашите документи',
  commonVerificationThisMayTakeUpToTwoBusinessDays: 'Това може да отнеме до 2 работни дни.',
  commonVerificationPhoneSubtitle: 'Тази стъпка ще ни помогне по-добре да защитим Вашите интереси.',
  commonVerificationPhoneNeeded: 'Ще ни трябва вашият телефон',
  commonVerificationPhoneNeededSubtitle: 'Моля, въведете внимателно вашия телефонен номер. Ще получите SMS с код за верификация.',
  commonVerificationInputFieldMandatory: 'Задължително поле',

  // stock details
  commonStockDetailsStatsTitle: 'Статистики',
  commonStockDetailsStatsAvgVolume: 'Ср. обем',
  commonStockDetailsStatsAvgPrice: 'Avg. Price',
  commonStockDetailsStatsPrevClose: 'Prev. Close',
  commonStockDetailsStatsOpen: 'Отваря',
  commonStockDetailsStatsLow: 'Мин.',
  commonStockDetailsStatsHigh: 'Макс.',
  commonStockDetailsStatsMarketCap: 'Паз. кап.',
  commonStockDetailsStatsWeek52Low: 'Мин.(52с.)',
  commonStockDetailsStatsWeek52High: 'Макс.(52с.)',
  commonStockDetailsStatsPE: 'Коеф. P/E',
  commonStockDetailsStatsDivYield: 'Дох.див',
  commonStockDetailsAboutCompanyTitle: 'За компанията',
  commonStockDetailsAboutCompanyCeo: 'CEO',
  commonStockDetailsAboutCompanyEmployees: 'Employees',
  commonStockDetailsAboutCompanySector: 'Sector',
  commonStockDetailsAboutCompanyIndustry: 'Industry',
  commonStockDetailsAboutCompanyHeadquarters: 'Headquarters',
  commonStockDetailsRecentNewsTitle: 'Актуални новини',
  commonStockDetailsMarketClosedMessage: 'Пазарът е затворен.\n Ранната сесия започва след: ',
  commonStockDetailsStatsPeopleAlsoTradeTitle: 'Други търгувани акции',
  commonStockDetailsReadMore: 'Прочети повече',
  commonStockDetailsShowMore: 'Покажи повече',
  commonStockDetailsShowLess: 'Покажи по-малко',

  // other
  commonSearchForStocks: 'Търси акции ...',
  commonSearchForSymbolTitle: 'Символи',
  commonSearchForETFsTitle: 'ETF-и',
  commonSearchForSymbol: 'Търси символ ...',
  commonSearchForNoSymbolFound: 'Няма намерени символи',
  commonInvalidValue: '-',
  commonNextButton: 'Продължи',
  commonConfirmButton: 'Потвърди',
  commonContinueButton: 'Продължи',
  commonContinueButton2: 'Продължете',
  commonDoneButton: 'Готово',
  commonSendButton: 'Изпрати',
  commonProceedButton: 'Продължи',
  commonFrom: 'От',
  commonTo: 'До',
  commonYearPicker: 'Избери година',
  commonCancelButton: 'Отмени',
  commonFundButton: 'Депозирай',
  commonRequestChangeButton: 'Поискай промяна',
  commonYes: 'Да',
  commonNo: 'Не',
  commonOkay: 'Oк',
  commonDontShowAgain: 'Не показвай това съобщение повече',
  commonNotNow: 'Не сега',
  commonGoBackBtn: 'Назад',
  commonViewMore: 'Виж повече',
  commonViewLess: 'Виж по-малко',
  commonSubscribe: 'Aбонирайте се',
  commonChoose: 'Избери',

  commonNotActivatetFundsPopUpText: 'Преди да захраните сметката си трябва да довършите създаването на профил.',

  // onboarding
  commonOnboardingInitialCountryTitle: 'Държава',
  commonOnboardingInitialCountryLabel: 'Държава на пребиваване',

  // Next Steps Activation screen
  commonNextStepsTitle: 'Още 3 стъпки, за да започнете да търгувате!',
  commonNextStepsTitleVerification: 'Още 2 стъпки, за да започнете да търгувате!',
  commonNextStepsTitleActive: 'Още 1 стъпка, за да започнете да търгувате!',
  commonNextStepsButtonTitle_1: 'Създайте профил',
  commonNextStepsButtonTitle_2: 'Активирайте профила си',
  commonNextStepsButtonTitle_3: 'Направете първи депозит',
  commonNextStepsButtonTitle_4: 'Верифицирайте профила си',
  commonNextStepsButtonTitle_5: 'Настройване на сметка',

  // account activation
  commonOnboardingAccountActivationTitle: 'Активиране на профил',

  // Enrollment Recovery
  commonEnrollmentPersonalDetailsTitle: 'Да започнем с основните неща',
  commonEnrollmentRecoveryTitle: 'Възстановяване на сесията',
  commonEnrollmentRecoverySubTitle: 'Продължете от последната достигната стъпка',
  commonEnrollmentRecoveryButtonTitle: 'Продължете от последната достигната стъпка',
  commonEnrollmentCreateProfileTitle: 'Създайте профил',
  commonEnrollmentCreateProfileSubTitle: 'Регистрирайте се за участие в играта.',
  commonEnrollmentEnterFirstName: 'Въведете име на латиница',
  commonEnrollmentEnterLastName: 'Въведете фамилия на латиница',
  commonEnrollmentEnterEmail: 'Въведете имейл',
  commonEnrollmentEnterPassword: 'Въведете парола',
  commonEnrollmentApprovePrivacyPolicy1: 'Съгласявам се с',
  commonEnrollmentApprovePrivacyPolicy2: 'Политиката за поверителност',
  commonEnrollmentApproveTournamentRule: 'Правилата на турнира',
  commonEnrollmentWelcomeMessage: 'Здравейте!',
  commonEnrollmentWelcomeMessageContent: 'Регистрирахте се успешно в турнира на Капитал. Желаем ви успех!',
  commonEnrollmentWelcomeMessageContentSubscriber: 'Като наш абонат получавате Бонус сметка за двойно по-голям шанс да спечелите',

  // Not Active Individual Notification
  commonNotActiveIndividualNotificationEnrollStepTitle: '1 стъпка по-близо, за да започнете да търгувате!',
  commonNotActiveIndividualNotificationEnrollStepDescription:
    'Регистрацията ви е успешна. Сега трябва да активирате профила си, да го верифицирате и да направите първия си депозит!',
  commonNotActiveIndividualNotificationVerificationStepTitle: 'Верифицирайте профила си!',
  commonNotActiveIndividualNotificationVerificationStepDescription: 'Направете депозит и ще можете да търгувате.',
  mobileNotActiveIndividualNotificationVerificationStepDescriptionRow1: 'Направете депозит и ще можете \n',
  mobileNotActiveIndividualNotificationVerificationStepDescriptionRow2: 'да търгувате.',
  commonNotActiveIndividualNotificationPendingVerificationStepTitle: 'Остана още малко!',
  commonNotActiveIndividualNotificationPendingVerificationStepDescription:
    'Верифицираме Вашите документи.\n Това може да отнеме до 3 работни дни.',
  commonNotActiveIndividualNotificationSettingUpYourAccount:
    'Настройваме Вашата сметка. Ще Ви уведомим, когато сме готови',

  // General Questions
  commonGeneralQuestionsTypeLabel: 'Тип',
  commonGeneralBinaryQuestionsError: 'Моля, изберете една от опциите.',

  commonGeneralQuestionsError: 'Моля, изберете@@1.',
  commonGeneralQuestionsDateError: 'Моля, изберете начална дата за "от".',
  commonGeneralQuestionsDateFromBiggerThanToError: 'Моля, изберете дата, по-малка от \'до\'.',

  commonGeneralQuestionsSubTitle1:
    'Следващите въпроси оценяват вашите трейдинг знания и опит. Това ще ни помогне да защитим по най-добрия начин Вашите интереси',
  commonGeneralQuestionsSubTitle2:
    'Регулаторите изискват от нас да събираме такава информация. Бъдете спокойни, погрижили сме се тя да бъде зашитена.',
  commonGeneralQuestionsSubTitle3: 'Спестявания, инвестиции и други активи (вкл. недвижими имоти)',
  commonUnspecifiedKnowledgeAndExperienceSectionTitle: 'Моля, изберете правилното твърдение:',
  commonEmploymentStatusSectionTitle: 'Каква е Вашата Заетост?',
  commonInvestmentAmountSectionTitle: 'Каква сума планирате да инвестирате?',
  commonAnnualNetIncomeSectionTitle: 'Какъв е Вашият нетен доход?',
  commonEstimatedNetWorthSectionTitle: 'Каква е стойността на притежаваните от Вас активи?',
  commonAmountTradesPerYearhSectionTitle: 'Какъв е средният обем на сделките Ви за година?',
  commonLeveragedProductsKnowlegeSectionTitle: 'Какви са Вашите познания относно финaнсови продукти с ливъридж?',
  commonLeveragedProductsKnowlegeSectionSubTitle: 'Акции на маржин, договори за разлика (ДЗР), форекс, фючърси, опции',
  commonGroupQuestionStatement1:
    'Когато стойността на Вашата сметка падне под изискуемия маржин, това ще предизвика автоматично затваряне на позициите Ви.',
  commonGroupQuestionStatement2: 'За да изпратите поръчка на стойност 10 000 долара при ливъридж 10 към 1, трябва да инвестирате 2 000 долара от Вашите средства.',
  commonAppropriatenessModalTitle: 'Оценка нн Финансовите познания',
  commonAppropriatenessModalBody1: 'Трябва да Ви уведомим, че на база на предоставените отговори относно Вапите знания и опит в областта на инвестициите, търговията с продукти с ливъридж не е подходяща за Вас. Продуктите с ливъридж са свързани с високо ниво на риск и могат до доведат до загуби, които надхвълрят депозираните от Вас средства.',
  commonAppropriatenessModalBody2: 'Като натискате Продължи Вие се съгласявате, че разбирате това предупреждение и сте наясно с рисковете при търговия с финансови продукти с ливъридж както и потвърждавате, че имате необходимите знания и опит, за да оцените напълно тези рискове.',
  commonAppropriatenessModalBody3: 'Изпратихме Ви и имейл с тазW информация.',
  commonIndustryTitle: 'Икономически сектор',
  commonInlineHelpButton: 'Не сте сигруни какво да направите? Свържете се с нас',
  commonSourceOfFundsFromLabel: 'От',
  commonSourceOfFundsToLabel: 'До',
  commonSourceOfFundsDateFromLabel: 'Начална дата',
  commonSourceOfFundsSectionTitle: 'Инвестиционни цели',
  commonSourceOfFundsSalaryTitle: 'Работна заплата',
  commonSourceOfFundsSalarySubtitle: 'Нужна ни е информация за периода на придобиване на средствата и други детайли, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsNameOfEmplLabel: 'Наименование на работодателя',
  commonSourceOfFundsNameOfCustomer: 'Наименование на основния клиент',
  commonSourceOfFundsAddressOfEmplLabel: 'Адрес на работодателя',

  commonSourceOfFundsSelfEmployedTitle: 'Доходи от самонаетост',
  commonSourceOfFundsSelfEmployedSubtitle: 'Нужна ни е информация за периода на придобиване на средствата и други детайли, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsHaveMainCustomer: 'Имам основен клиент',
  commonSourceOfFundsNameOfCustomerLabel: 'Наименование на основния клиент',
  commonSourceOfFundsAddressOfCustomerLabel: 'Адрес на клиента',

  commonSourceOfFundsHomeTradingTitle: 'Търговия с финансови инструменти от дома',
  commonSourceOfFundsHomeTradingSubtitle: 'Нужна ни е информация за периода на придобиване на средствата и други детйали, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsBrokerNameLabel: 'Наименование на инвестиционния посредник',

  commonSourceOfFundsFamMemberTitle: 'Член на семейството',
  commonSourceOfFundsFamMemberSubtitle:
    'Моля, пссочете периода, в който са придобити средствата и името на Вашия роднина. Тази информация ни е нужна, за да отговорим на регулаторни изисквания',
  commonSourceOfFundsFamMemberNameLabel: 'Трите имена на члена на семейството',

  commonSourceOfFundsInheritanceTitle: 'Наследство',
  commonSourceOfFundsInheritanceSubtitle: 'Нужна ни е информация за основния източник на Вашите средства за инвестиции, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsYearOfLabel: 'Година на получаване на наследството',
  commonSourceOfFundsNameOfDeceasedLabel: 'Трите имена на починалото лице',
  commonSourceOfFundsBirthYearLabel: 'Година на раждане на починалото лице',

  commonSourceOfFundsInvestmentSavingsTitle: 'Инвестиции и спестявания',
  commonSourceOfFundsInvestmentSavingsSubtitle: 'Нужна ни е информация за основния източник на Вашите средства за инвестиции, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsInvestmentSavingsTypesTitle: 'Тип',
  commonSourceOfFundsInvestmentSavingsTypes: 'Недвижими имоти, финансови инструменти, дивиденти, друго',
  commonSourceOfFundsInvestmentSavingsTypesPleaseSpecify: 'Моля, поосочете',
  commonSourceOfFundsInvestmentSavingsTypesRealEstate: 'Недвижими имоти',

  commonSourceOfFundsTitle: 'Какъв е източникът на средствата, които ще инвестирате?',
  commonSourceOfFundsPensionBenefitsTitle: 'Пенсия / Обезщетения',
  commonSourceOfFundsPensionBenefitsSubtitle: 'Нужна ни е информация за основния източник на Вашите средства за инвестиции, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsPensionBenefitsTypes: 'Пенсия,обезщетения',
  commonSourceOfFundsPensionBenefitsTypesTitle: 'Tип',
  commonSourceOfFundsPension: 'Пенсия',
  commonSourceOfFundsSocialBenefits: 'Обезщетения',

  commonSourceOfFundsLoanTitle: 'Заем',
  commonSourceOfFundsLoanSubtitle: 'Нужна ни е информация за основния източник на Вашите средства за инвестиции, за да отговорим на регулаторни изисквания.',
  commonSourceOfFundsLenderNameLabel: 'Наименование на заемодателя',
  commonSourceOfFundsLenderType: 'Тип заемодател',
  commonSourceOfFundsLoanTypes: 'Банка / друга институция , друго физическо / юридическо лице',

  // onboarding
  commonOnboardingSectionTitlePersonalData: 'Лични данни',
  commonOnboardingSectionTitleKnowledgeAndExperience: 'Опит',
  commonOnboardingSectionTitlePurposeAndStatus: 'Статут',
  commonOnboardingSectionTitleAgreementsAndPolicies: 'Документи',

  // transitions screens
  commonOnboardingTransitionGetStartedButtonTitle: 'Започни',
  commonOnboardingTransitionButtonTitle: 'Продължи',
  commonOnboardingTransitionPurposeAndStatus: 'Статут',
  commonOnboardingTransitionPurposeAndStatusDescription: 'Тази секция ще ни помогне да определим Вашия трейдинг профил',
  commonOnboardingTransitionExperience: 'Опит',
  commonOnboardingTransitionExperienceDescription:
    'Следващите въпроси оценяват Вашите трейдинг знания и опит. Това ще ни помогне да защитим по най-добрия начин Вашите интереси',

  commonOnboardingExperienceTradeStockLikePros: 'Търгувайте акции като професионалист!',
  commonOnboardingExperienceJustAnswerAFewQuestionsToHelpUs: 'Трябва само да отговорите на няколко въпроса, за да настроим Вашия профил и всичко е готово.',
  commonOnboardingExperienceYourKnowledge1: 'Регулаторите изискват от нас да оценим Вашия опит и знание.',
  commonOnboardingExperienceYourKnowledge2: 'Още няколко въпроса и всичко е готово',
  commonOnboardingExperienceAccountUpAndRunning: 'Вашата трейдинг сметка е настроена и активирана!',
  commonOnboardingExperienceJustFundYourAccount: 'Сега вече нищо не Ви спира! \n Остава само да заредите сметката си, за да търгувате.',
  commonOnboardingExperienceRequiredByRequlators: 'Регулаторите изискват от нас да оценим Вашия опит и знания.',
  commonOnboardingExperienceAFewQuestion: 'Още няколко въпроса и всичко е готово',
  commonOnboardingExperienceTradingProfileComplete: 'Страхотно! Профилът Ви е завършен',
  commonOnboardingExperienceItMayTakeADay: 'Може да отнеме до 1 работен ден преди сметката Ви да е готова за търговия. Ще Ви уведомим, \n когато сме готови.',

  // startup screen
  commonOnboardingCarousel1Title: 'Добре дошли в 10n',
  commonOnboardingCarousel1Description: 'Вашият пътеводител в света на търговията с финнанови инструменти. Където и да сте.\n Без комисион!',
  commonOnboardingCarousel2Title: 'Какво е 10n?',
  commonOnboardingCarousel2Description: 'Решение за финансовия пазар за всеки амбициозен трейдър. Изградете портфолиото си по Ваш избор!',
  commonOnboardingCarousel3Title: 'Всичко, от което имате нужда. В едно приложение.',
  commonOnboardingCarousel3Description:
    'Финансови отчети и статистика, актуани новини и пазарна информация - всички необходими инструменти, за да започнете да търгуварте с лекота и увереност!',
  // sign in screen (email, name etc.)
  commonOnboardingSignInTitle: 'Създайте първо Вашия профил',
  commonOnboardingSignInSubtitle: '',
  commonOnboardingSignInEmail: 'Имейл',
  commonOnboardingSignInPassword: 'Парола',
  commonOnboardingSignInPrivacyPolicy: 'Политика за поверителност',
  commonOnboardingSignInCoockiePolicy: 'Политика за бисквитки',
  commonOnboardingSignIn10nPrivacyPolicy: 'Политика за поверителност',
  commonOnboardingSignInOrRegisterWith: 'Или се регистрирайте с:',
  commonOnboardingSignInButtonCreateAccount: 'Създайте профил',
  commonOnboardingSignInValidation8Chart: 'Минимум 8 символа',
  commonOnboardingSignInValidation32Chart: 'Максимум 30 символа',
  commonOnboardingSignInValidationUpperCaseLetter: 'Главна буква',
  commonOnboardingSignInValidationLowerCaseLetter: 'Малка буква',
  commonOnboardingSignInValidationSpecialSymbol: 'Специален символ',
  commonOnboardingSignInValidationNumber: 'Цифра',
  commonOnboardingSignInValidationLatinCharacters: 'Латиница',
  commonOnboardingSignInErrorMessage: 'Възника грешка.',
  commonOnboardingSignInErrorMessagePart1: 'Моля,@@1',
  commonOnboardingSignInErrorMessagePart2: 'свържете се с нас',
  commonOnboardingSignInErrorMessagePart3: '@@1за съдействие.',

  commonPolicyAgreement: 'Съгласявам се личните ми данни да бъдат използвани в съответствие с ',
  commonAnd: ' и ',
  commonPolicyAgreementErrorMessage:
    'Моля, отбележете, че сте прочели и сте съгласни с Политиката за поверителност',
  commonTournamentPolicyAgreementErrorMessage: 'Моля, отбележете, че сте прочели и сте съгласни с условията на турнира',

  // confirm email
  commonOnboardingMismatchTitle: 'Неправилен линк',
  commonOnboardingMismatchDescription:
    'Имейлът от линка не съвпада с регистрирания имейл. Моля използвайте линка от \'@@1\' или влезте с \'@@2\', за да използвате настоящия линк.',
  commonOnboardingEmailConfirmTitle: 'Нека потвърдим имейла',
  commonOnboardingEmailConfirmProgress: 'Проверка на имейла ...',
  commonOnboardingEmailConfirmResending: 'Повторно изпращане...',
  commonOnboardingEmailConfirmDescription1: 'Изпратихме Ви имейл с линк за потвърждение на',
  commonOnboardingEmailConfirmDescription2: 'Моля отворете и кликнете върху линка, за да продължите с регистрацията',
  commonOnboardingEmailSpamDescription1: 'Не сте получили имейл за потвърждение',
  commonOnboardingEmailSpamDescription2: 'Проверете вашата СПАМ папка',
  commonOnboardingEmailConfirmButtonOpenEmailApp: 'Отворете Вашия имейл',
  commonOnboardingEmailConfirmButtonResendEmail: 'Изпратете отново',
  commonOnboardingEmailConfirmButtonResendEmailIn: 'Изпратете отново след',
  commonOnboardingEmailConfirmInvalidEmailMessage: 'Имейл адресът е невалиден.',
  commonOnboardingEmailConfirmedTitle: 'Вашият имейл е потвърден успешно!',
  commonOnboardingEmailConfirmedDescription1: 'Благодарим за регистрацията!\n Сега можете да се впуснете във вселената на 10n.',
  commonOnboardingEmailConfirmedDescription2: 'Нядяваме се, че приключението ще ви хареса.',
  commonOnboardingEmailAccountHasBeenConfirmed: 'Профилът беше потвърден.',
  commonOnboardingEmailCompleted: 'Моля, натиснете бутона “Продължете”, за да продължите с регистрацията.',

  // Expired verification modal
  commonOnboardingExpiredVerificationLinkTitle: 'Линкът за потвърждение изтече.',
  commonOnboardingExpiredVerificationLinkBody: 'Моля, регистрирайте се отново или влезте, ако вече имате регистрация.',
  // recovery
  commonOnboardingRecoveryTitle: 'Възстановяване на сесията',
  commonOnboardingRecoveryDescription: 'Приложението Ви отведе на последната достигната стъпка от процеса по съдаване на Вашия профил. Моля, продължете.',
  // phone verification
  commonOnboardinghoneCountryCode: 'Код',
  commonOnboardingPhoneVerificationTitle: 'Ще ни трябва Вашият телефон',
  commonOnboardingPhoneVerificationShortDescription: 'Ще получите SMS с код за верификация, за да потвърдите номера. Моля, въведете го внимателно в полето долу:',
  commonOnboardingPhoneVerificationSubtitle: 'Тази стъпка ще ни помогне да защитим данните Ви.',
  commonOnboardingPhoneVerificationCountry: 'Държава',
  commonOnboardingPhoneVerificationPhoneNumber: 'Телефонен номер',
  commonOnboardingPhoneVerificationPhoneNumberInvalid: 'Номерът е невалиден!',
  commonOnboardingPhoneVerificationSearchCodePlaceholder: 'Търси...',
  commonOnboardingPhoneVerificationSMSCodeTitle: 'Да потвърдим телефонния номер',
  commonOnboardingPhoneVerificationSMSCodeSubitle: 'Моля, въведете кода, който изпратихме с SMS на номер @@1',
  commonOnboardingPhoneVerificationSMSCodeNotReceived: 'Не получихте кода?',
  commonOnboardingPhoneVerificationSMSCodeExpriesIn: 'Изпращане на нов код след - ',
  commonOnboardingPhoneVerificationResend: 'Изпращане на нов код',
  commonOnboardingPhoneVerificationSMSCodeControlLabel: '6-цифрен код',
  commonOnboardingPhoneVerificationInvalidCodeLength: 'Невалиден код',
  commonOnboardingPhoneVerificationCodeDoesNotMatch: 'Кодът не съвпада',
  commonOnboardingPhoneVerificationCodeSendAgainErrorMessage: 'Моля, опитайте отново',
  commonOnboardingPhoneVerificationCodeClientErrorMessage: 'Невалиден код',

  // countries
  commonOnboardingCountriesSearch: 'Търси държава ...',
  commonOnboardingCountriesNoMatch: 'Няма намерени',
  // personal details
  commonOnboardingGenericRequiredField: 'Полето',
  commonOnboardingGenericFieldFrom: 'От',
  commonOnboardingGenericFieldIsRequired: '@@1 е задължително.',
  commonOnboardingPersonalDetailsTitle: 'Да започнем с основните неща',
  commonOnboardingPersonalDetailsSubtitle: 'Според международното законодателство всички инвестиционни посредници трябва да събират такава информация',
  commonOnboardingPersonalDetailsFirstName: 'Име',
  commonOnboardingPersonalDetailsFirstNameErrorMessage:
    'Името трябва да съдържа само латински букви, никакви специални символи и да бъде поне от 2 букви.',
  commonOnboardingPersonalDetailsStringErrorMessage:
    '@@1 Името трябва да съдържа само латински букви, никакви специални символи и да бъде поне от 2 букви.',
  commonOnboardingPersonalDetailsLastName: 'Фамилия',
  commonOnboardingPersonalDetailsMiddleNameOptional: 'Презиме (незадължително)',
  commonOnboardingPersonalDetailsLastNameErrorMessage:
    'Фамилното име трябва да съдържа само латински букви, никакви специални символи и да бъде поне от 2 букви.',
  commonOnboardingPersonalDetailsMiddleName: 'Презиме (незадължително)',
  commonOnboardingPersonalDetailsMiddleNameErrorMessage:
    'Презимето е незадължително - трябва да съдържа само латински букви, никакви специални символи и да бъде поне от 2 букви.',
  commonOnboardingPersonalDetailsDateOfBirth: 'Рожденна дата',
  commonOnboardingPersonalDetailsDateOfBirthErrorMessage: 'Моля, изберетe рожденна дата.',
  commonOnboardingPersonalDetailsNationality: 'Националност',
  commonOnboardingPersonalDetailsCountryOfBirth: 'Държава на раждане',
  commonOnboardingPersonalDetailsPlaceOfBirth: 'Месторождение',
  commonOnboardingPersonalDetailsNationalityCitizenship: 'Националност / Гражданство',
  commonOnboardingPersonalDetailsNamedCountryErrorMessage: 'Моля изберете @@1.',
  commonOnboardingPersonalDetailsDocumentError: 'Грешка',
  commonOnboardingPersonalDetailsDocumentType: 'Тип документ',
  commonOnboardingPersonalDetailsDocumentTypeErrorMessage: 'Моля, изберете типа документ.',
  commonOnboardingPersonalDetailsDocumentTitle: 'И накрая документ за самоличност',
  // TODO: delete this text when the mobile change is made
  commonOnboardingPersonalDetailsDocumentSubtitle:
    'Тази информация ни е нужна поради регулаторни изиксвания. Документът трябва да е с валиден срок и да съдържа Ваша снимка.',
  commonOnboardingPersonalDetailsIDDocumentSubtitle: 'Документът трябва да е с валиден срок и да съдържа Ваша снимка',
  commonOnboardingPersonalDetailsDocumentID: 'Документ за самоличност',
  commonOnboardingPersonalDetailsDocumentSubtypeUnspecified: 'Неопределен',
  commonOnboardingPersonalDetailsDocumentSubtypePassport: 'Паспорт',
  commonOnboardingPersonalDetailsDocumentSubtypeIdentityCard: 'Лична карта',
  commonOnboardingPersonalDetailsDocumentSubtypeDrivingLicense: 'Шофьорска книжка',
  commonOnboardingPersonalDetailsDocumentNonExpring: 'Безсрочен',
  commonOnboardingPersonalDetailsDocumentNumber: 'Документ за самоличност №',
  commonOnboardingPersonalDetailsDocumentNumberErrorMessage: 'Полето не може да е празно или да съдържа специални символи.',
  commonOnboardingPersonalDetailsDateOfExpiry: 'Дата на валидност',
  commonOnboardingPersonalDetailsDateOfExpiryErrorMessage: 'Моля, изберете дата на валидност.',
  commonOnboardingPersonalDetailsCitizenshipSameAsConutryOfBirth: 'Гражданството съвпада с държавата по месторождение',
  commonOnboardingPersonalDetailsResidentialAddress: 'Да продължим с Вашия адрес',
  commonOnboardingPersonalDetailsResidentialAddressSubtitle: 'Адресът трябва да съвпада с адреса по документа за самоличност.',
  commonOnboardingPersonalDetailsMailingAddress: 'Адрес за кореспонденция',
  commonOnboardingPersonalDetailsPhoneNumber: 'Телефонен номер',
  commonOnboardingPersonalDetailsView: 'Виж Лични данни',
  commonOnboardingPersonalDetailsCountry: 'Държава',
  commonOnboardingPersonalDetailsCountryErrorMessage: 'Моля, изберете държава.',
  commonOnboardingPersonalDetailsCity: 'Град',
  commonOnboardingPersonalDetailsCityErrorMessage: 'Полето за град не може да е празно или да съдържа специални символи.',
  commonOnboardingPersonalDetailsPostCode: 'Пощ. код',
  commonOnboardingPersonalDetailsPostCodeErrorMessage: 'Полето за пощ. код не може да е празно или да съдържа специални символи.',
  commonOnboardingPersonalDetailsAddress: 'Адрес',
  commonOnboardingPersonalDetailsAddressErrorMessage: 'Полето за адрес не може да е празно или да съдържа специални символи.',
  commonOnboardingPersonalDetailsSameAsMailingAddress: 'Адресът за кореспонденция съвпада с адреса по местоживеене',
  commonOnboardingPersonalDetailsTaxDetailsTitle: 'Данни за данъчни цели',
  commonOnboardingPersonalDetailsTaxDetailsMainCountry: 'Основна държава за данъчни цели',
  commonOnboardingPersonalDetailsTaxDetailsTaxNumber: 'Данъчен номер',
  commonOnboardingPersonalDetailsTaxDetailsTaxNumberErrorMessage: 'Полето за данъчен номер не може да е празно.',
  commonOnboardingPersonalDetailsTaxDetailsTaxNumberAlreadyInUseMessage: 'Този данъчен номер вече се използва.',
  commonOnboardingPersonalDetailsTaxDetailsTaxNumberServerErrorMessage: 'Възникна грешка. Моля, опитайте отново!',
  commonOnboardingPersonalDetailsTaxDetailsMainTaxDetails: 'Основни данни за данъчни цели',
  commonOnboardingPersonalDetailsTaxDetailsTaxCountry: 'Държава',
  commonOnboardingPersonalDetailsTaxDetailsSecondaryTaxDetails: 'Допълнителни данни за данъчни цели',
  commonOnboardingPersonalDetailsTaxDetailsAddFromDifferentCountry: 'Добавете даннъчни дани от друга държава',
  commonOnboardingPersonalDetailsTaxNumberMessage:
    'Данъчният номер е обикновено Вашето ЕГН. За допълнително информация и насоки можете да се свържете с НАП.',
  commonOnboardingPersonalDetailsCitizenship: 'Гражданство',
  commonOnboardingPersonalDetailsTaxCountrySameAsCOB: 'Държавата за данъчни цели съвпада с държавата по месторождение',
  commonOnboardingPersonalDetailsAddAnotherCitizenship: 'Добавете друго гражданство',
  commonOnboardingPersonalDetailsAnotherCitizenshipDefaultParameter: 'Друго',
  commonOnboardingPersonalDetailsAnotherCitizenshipParameter:
    'Друга,Следваща,Следваща,Следваща,Следваща,Следваща,Следваща,Следваща,Следваща',
  commonOnboardingPersonalDetailsAddAnotherTaxCountry: 'Добави друга държава',
  commonOnboardingPersonalDetailsAddressUnderlineText: 'улица, ап, номер и др.',
  commonOnboardingPersonalDetailsErrorMessage1: 'Възникна грешка при записвнето на личните данни',
  commonOnboardingPersonalDetailsErrorMessage2: 'Възникна греша при записването на данните',
  commonOnboardingPersonalDetailsErrorMessage3: 'Възника грешка при записването на данните',
  commonOnboardingPersonalDetailsUnderEighteenError: 'Трябва да сте поне на 18 години, за да създадете профил.',
  commonOnboardingPersonalDetailsChooseDocument: 'Изберете документ',

  // Common validations
  commonValidationTextInvalid: '@@1 е навалиден.',
  commonOnboardingPersonalDetailsDocumentExpireDateError: 'Датата на валидност не трябва да е по-късна от "sys date + 30 дни".',
  commonErrorRegister1: 'Възникна проблем. Моля,',
  commonErrorRegister2: 'свържете се с нас',
  commonErrorRegister3: 'за съдействие',

  // Tax Details
  commonTaxDetailsDescription: '10n е задължен да събира такава информация',

  // Edit Document
  commonEditDocumentUploadProofOfIdentity: 'Прикачи Документ за самоличност*',
  commonEditDocumentBothSides: 'И дете страни на документа за самоличнот',
  commonEditDocumentNonExpiringDocument: 'Безсрочен документ',

  // Legal declarations
  commonOnboardingLegalTitle: 'Общи условия',
  commonOnboardingLegalText1: 'Прочетох, разбрах и потвърждавам, че приемам документите по-горе.',
  commonOnboardingLegalText2:
    'Искам да си отворя сметка за маржин търговия. Разбирам, че загубите ми могат да надхвърлят първоначалните ми инвестиции.',
  commonOnboardingLegalCheckBtn1:
    'Съгласявам се да бъда обвързан с всички горепосочени декларации и потвърждавам, че сключвам по електронен път правно обвързващ договор във форма на Клиентски договор.',
  commonOnboardingLegalCheckBtn2:
    'Съгласявам се с условията, псочени в Политиката за поверителност, която описва как 10n обработва и съхранява лични данни и моите права във връзка с тези данни.',
  commonPep1: 'Декларирам, че през последните 12 месеца не съм попадал в категорията',
  commonPep2: 'видна политическа личност по смисъла на чл. 36, ал. 5 от ЗМИП ',
  commonPep3: 'нито съм бил член на семейство, свързано лице или близък бизнес сътрудник на видна политическа личност.',
  commonPepDescriptionTitle: 'Видна политическа личност',
  commonPepDescription: 'Държавни глави, ръководители на правителства, министри и заместник-министри или помощник-министри;\n'
    + 'членове на парламенти или на други законодателни органи;\n'
    + 'членове на конституционни съдилища, на върховни съдилища или на други висши органи на съдебната власт, чиито решения не подлежат на последващо обжалване освен при изключителни обстоятелства;\n'
    + 'членове на сметна палата;\n'
    + 'членове на управителни органи на централни банки;\n'
    + 'посланици и управляващи дипломатически мисии;\n'
    + 'висши офицери от въоръжените сили;\n'
    + 'членове на административни, управителни или надзорни органи на държавни предприятия и търговски дружества с едноличен собственик – държавата;\n'
    + 'кметове и заместник-кметове на общини, кметове и заместник-кметове на райони и председатели на общински съвети;\n'
    + 'членове на управителните органи на политически партии;\n'
    + 'ръководители и заместник-ръководители на международни организации, членове на управителни или надзорни органи в международни организации или лица, изпълняващи еквивалентна функция в такива организации.',

  commonOnboardingLegalCheckBtn4: 'Изпратете копие до мен',
  commonOnboardingLegalError: 'Възникна грешка.',
  commonOnboardingLegalSubmitBtnText: 'Готово',

  commonTheInformationIHaveProvided: 'С настоящото декларирам, че предоставената от мен информация е вярна и точна и ще уведомя за настъпването на всякакви съществени промени в нея.',
  commonIHaveRead: 'Прочетох, разбрах и потвърждавам, че приемам документите по-горе.',
  commonIUnderstand: 'Разбирам, че загубите ми могат да надхвърлят първоначалната ми инвестиция.',

  commonWelcomeToTournament: 'Добре дошли в турнира на Капитал!',
  commonWelcomeToTournamentDescription: 'Разгледайте платформата и инструментите преди да започнете, за да постигнете най-добри резултати!',
  commonWelcomeToTournamentStartingAt: 'Започваме след:',
  commonTournamentEndingAt: 'До края остават:',
  commonTournamentEndAppoaching: 'Краят на турнира наближава',
  commonTournamentEndAppoachingDesc: 'Всички отворени позиции в края на последния ден на турнира (09.05) ще бъдат закрити автоматично и изчислени по официалната цена на затваряне за деня. Така ще се формира официалното окончателно класиране.',
  commonWelcomeTo10nTrade: '@@1 @@2 Добре дошли в 10n',
  commonYouMayRead: 'Докато верифицираме профила Ви можете да се запознаете с приложените Общи условия.',
  commonAccountSettingUp: 'Активацията отнема до минути. Ако е направена в неработен ден, ще стане в първия работен.',

  // Yay Activated
  commonOnboardingYayTitle: 'Ура! Профилът Ви е активиран!',
  commonOnboardingYaySubtitle: 'Отключихте функционалност Плащания.',
  commonOnboardingYaySubmitBtnText: 'Продължи',
  commonOnboardingYayNextStepsLeft: 'Остават още две стъпки',

  // upload
  commonOnboardingUploadBtn: 'Прикачи',
  commonOnboardingUploadCondition1: 'Прикачи снимка на двете страни на Документа за самоличност',
  commonOnboardingUploadCondition2: 'Документът има валидна дата на валидност',
  commonOnboardingUploadCondition3: 'Данните са четими и се виждат ясно',
  commonOnboardingUploadTitle: 'Моля, прикачете следните документи',
  commonOnboardingUploadProofOfID: 'Прикачете Документ за самоличност',
  commonOnboardingUploadPassport: 'Прикачете Вашия паспорт',
  commonOnboardingUploadBothSidesID: 'Прикачете Вашата лична карта',
  commonOnboardingUploadProofOfAddress: 'Документ за доказване на адреса по местоживеене',
  commonOnboardingUploadProofOfAddressText1:
    'Банково извлечение / Фактура за битова сметка, издадена през последните три месеца',
  commonOnboardingUploadProofOfAddressText2: 'Пълното Ви име и адрес както и наименованието на издателя на документа трябва да са ясно видими',
  commonOnboardingUploadProofOfAddressText3: 'Допустими формати: jpg, png only - до 10mb',
  commonOnboardingUploadDocDescription:
    'За да верифицираме профила Ви, ще ни е нужна снимка на Вашия документ за самоличност. Имайте предвид следното:',
  commonOnboardingUploadBankStatementOrUtilityBill: 'Банково извлечение или фактура за битова сметка',
  commonOnboardingUploadDocumentConfirmDescription: 'Моля, уверете се, че документът е четим и нужните реквизити са видими.',
  commonOnboardingUploadBackSideOfCardButton: 'Нова снимка',
  commonOnboardingUploadSelfieTitle: '',
  commonOnboardingUploadSelfieDescription:
    'За да верифицираме самоличността Ви и избегнем финансова измама, моля, направете си селфи.\n\nИмайте предвид следното:\n\n• На снимката сте само Вие;\n\n• С лице към камерата;\n\n• Снимката е ясна и светла',
  commonOnboardingUploadSelfieProceedButton: 'Продължи',
  commonOnboardingUploadSelfieConfirmDescription: 'Уверете се, че лицето Ви е ясно видимо и снимката не е размазана.',
  commonOnboardingUploadSelfieConfirmConfirmButton: 'Потвърди',
  commonOnboardingUploadSelfieConfirmSnapButton: 'Снимай',
  commonOnboardingAndroidCamerPermissionsTitle: 'Разрешение за ползване на камера на телефона',
  commonOnboardingAndroidCamerPermissionsMessage: 'Нужно ни е разрешение за ползване на Ващата камера',
  commonOnboardingAndroidCamerPermissionsPositiveButton: 'Ok',
  commonOnboardingAndroidCamerPermissionsNegativeButton: 'Отмени',
  commonOnboardingAndroidAudioPermissionsTitle: 'Разрешение за ползване на аудио запис',
  commonOnboardingAndroidAudioPermissionsMessage: 'Нужно ни е разрешение за ползване на аудио запис ',
  commonOnboardingAndroidAudioPermissionsPositiveButton: 'Ok',
  commonOnboardingAndroidAudioPermissionsNegativeButton: 'Отмени',

  // Verification
  commonVerificationTitle: 'Верифициране',
  commonVerificationSubtitle: 'За да отговорим на регулаторните изисквания за търговия с финансови инструменти, трябва да верифицираме Вашата самоличност',
  commonVerificationProcessTimeDescription: 'Обикновено процесът по верификация на Вашите документи',
  commonVerificationProcessTimeSubDescription: 'отнема до 3 работни дни',
  commonVerificationVerifyPhoneNumberButton: 'Потвърдете Вашия телефонен номер',
  commonVerificationPhoneVerified: 'Телефонът е потвърден',
  commonVerificationVerifyPhoneNumberButtonDescription: 'За допълнителна сигурност и бърз достъп',
  commonVerificationUploadIdDocumentButton: 'Прикачи документ за самоличност',
  commonVerificationIdDocumentUploaded: 'Документът е прикачен',
  commonVerificationUploadIdDocumentButtonDescription: 'Копие на документа, използван за активиране на профила',
  commonVerificationPoAButton: 'Документ за доказване адреса по местоживеене',
  commonVerificationPoAUploaded: 'Документът е прикачен',
  commonVerificationPoAButtonDescription: 'Ясно и четимо копие на банково извлечение или фактура за битова сметка',
  commonVerificationStepStatusPending: 'Тече процес по верификация',
  commonVerificationStepStatusAccepted: 'Завършен',
  commonVerificationUploadPoITitle: 'Прикачи документ за самоличност',
  commonVerificationUploadPoIPassportTitle: 'Прикачи паспорт',
  commonVerificationUploadPoISubTitle:
    'За да верифицираме Вашкия профил, ще ни е нужна снимка на Вашия документ за самоличност. Имайте предвид следното:',
  commonVerificationUploadPoIBullet1: 'Прикачете снимка на двете страни на документа',
  commonVerificationUploadPoIBullet2: 'Документът има валидна дата на валидност',
  commonVerificationUploadPoIBullet3: 'Личните Ви данни са ясно видими',
  commonVerificationUploadFrontIDImageTitle: 'Лице на документа',
  commonVerificationUploadIDImageSubtitle: 'Дръжте документа с ръка и направете снимка.',
  commonVerificationUploadBackIDImageTitle: 'Гръб на документа',
  commonVerificationUploadPassportImageTitle: 'Паспорт',
  commonVerificationUploadPoATitle: 'Прикачи паспорт',
  commonVerificationUploadPoASubTitle1:
    'Можете да използвате елетронно банково извлечение или фактура за битова сметка (например газ, елетричество, вода или стационарен телефон, без сметки за мобилни телефони).',
  commonVerificationUploadPoASubTitle2: 'Документът трябва да съдържа пълното Ви име и адрес както и наименованието на издателя. Той трябва да бъде издаден',
  commonVerificationUploadPoASubTitle3: 'през последните 3 месеца.',
  commonVerificationUploadPoAChooseDocumentLabel: 'Избери тип документ:',
  commonVerificationUploadPoAUtilityBill: 'Битова сметка',
  commonVerificationUploadPoABankStatement: 'Банково извлечение',
  commonVerificationUploadFileSizeExceededMessage: 'Максималният допустим расмер от 10mb е надхвърлен',
  commonVerificationUploadFileWrongFormatMessage: 'Неподдържан формат на файла. Моля, проверете кои са разрешените формати',
  commonVerificationTermsButton: 'Общи условия',
  commonVerificationTermsButtonDescription: 'Споразумения и обши условия',

  // Upload document
  commonUploadDocumentTypesHint: '*Допустими формати : @@1 - до 10mb',
  commonUploadDocumentLabel1: 'Постави снимката тук или',
  commonUploadDocumentLabel2: 'прикачи',
  commonUploadDocumentWebTitle1:
    'За да верифицираме Вашия профил, ни е нужна снимка от първата страница на банково извлечение. издадено през последните три месеца.',
  commonUploadDocumentWebTitle2: 'Документът трябва да съдържа ясно четими:',
  commonUploadDocumentWebLabel1: 'Вашето пълно име и адрес',
  commonUploadDocumentWebLabel2: 'Наименованието на банката',
  commonUploadDocumentWebLabel3: 'Банковата сметка',
  commonUploadDocumentErrorTitle: 'Неуспешно прикачване',
  commonUploadDocumentErrorBody: 'За съжаление възникна проблем при прикачването.',
  commonUploadDocumentErrorBody1: 'Моля, уверете се, че форматът на файла е един от допустимите jpg, jpeg or png и е до 10mb.',

  // discover
  commonDiscoverTitle: 'Пазарни скенери',

  // Discover - Calendars
  commonDiscoverSubtitleCalenders: 'Календари',
  commonDiscoverCalenderSectionIPOs: 'IPO - та',
  commonDiscoverCalenderSectionIPOsTitle: 'IPO Календар',
  commonDiscoverCalenderSectionEarnings: 'Финансови отчети',
  commonDiscoverCalenderSectionEarningsTitle: 'Финансови отчети',
  commonDiscoverCalenderSectionEarningsDescription: 'Предстоящо публикуване\n на фин.резултати на компаниите',
  commonDiscoverCalenderSectionCompanyEvents: 'Корпоративни събития',
  commonDiscoverCalenderSectionCompanyEventsTitle: 'Корпоративни събития',
  commonDiscoverCalenderSectionAll: 'Всички',
  commonDiscoverCalenderSectionAllTitle: 'Всички календари',
  commonDiscoverCalenderEventsToday: 'Днес',
  commonDiscoverCalenderItems: 'Събития',
  commonDiscoverCalenderSectionTimeBeforeMarketOpen: 'Ранна сесия',
  commonDiscoverCalenderSectionTimeAfterMarketClose: 'Късна сесия',
  commonDiscoverCalenderSectionTimeNotSupplied: 'Няма данни',
  commonDiscoverCalenderSectionTimeEPSEstimate: 'EPS прогноза • $@@1',
  commonDiscoverCalenderSectionTimeNoEPSEstimate: 'EPS прогноза -',

  // Discover - New on the market - N/A
  commonDiscoverSubtitleNewOnTheMarket: 'New on the Market',
  commonDiscoverSubtitleNewOnTheMarketPastDays: 'For the past 30 days',

  // Discover - Long term investments
  commonDiscoverSubtitleLongTermInvestments: 'Дългосрочни инвестиции',
  commonDiscoverSubtitleLongTermInvestmentsTableHeader1: 'Символ / Компания',
  commonDiscoverSubtitleLongTermInvestmentsTableHeader2: 'Настоящо тримесечие',
  commonDiscoverSubtitleLongTermInvestmentsTableHeader3: 'Предишно тримесечие',
  commonDiscoverSubtitleLongTermInvestmentsTableHeader4: 'Пазарна капитализация',
  commonDiscoverSubtitleLongTermInvestmentsTableHeader5: 'Обем',

  // Discover - News
  commonDiscoverNews: 'Актуални новини',

  // Discover - Earnings Calendar
  upcomingEarnings: 'Финансови отчети',
  upcomingEarningsText: 'Предстоящо публикуване на фин.резултати на компаниите.',

  // Discover - 52 Week Highs
  commonDiscoverDailyPercentChange: 'днес.',
  commonDiscover52WeekPercentChange: '52 с.',
  commonDiscover52WeekPercentChangeMobile: 'Днес /52 с.',
  commonDiscover52WeekNoData: 'Няма символи, които отговарят на критериите на скенера. Проверете по-късно',
  commonDiscover52WeekNoDataAll: 'В момента няма символи, които отговарят на критериите на скенера. Моля, проверете по-късно',

  // Discover - Popular groups -
  commonDiscoverSubtitlePopularGroups: 'Сектори / индустрии',
  commonDiscoverPopularGroupsStocks: 'Акции',
  commonDiscoverPopularGroupsSortBy: 'Сортирай по',

  popularGroupCommunications: 'Communications',
  popularGroupHealthcare: 'Healthcare',
  popularGroupConsumerDiscretionary: 'Consumer Discretionary',
  popularGroupTechnology: 'Technology',
  popularGroupUtilities: 'Utilities',
  popularGroupConsumerStaples: 'Consumer Staples',
  popularGroupFinancialServices: 'Financial Services',
  popularGroupBasicMaterials: 'Basic Materials',
  popularGroupRealEstate: 'Real estate',
  popularGroupIndustrials: 'Industrials',
  popularGroupEnergy: 'Energy',
  popularGroupETFs: 'ETFs',
  popularGroupGappers: 'Gappers',

  // Discover - Charts - Dividend payers - High growth companies
  commonDiscoverDividendPayers: 'Дивиденти',
  commonDiscoverDividendPayersDescription: 'Дивидентен доход за последните 12 месеца',
  commonDiscoverHighGrowthCompaniesDescription: 'Най-бързо растящите компании за последните 12 месеца',
  commonDiscoverDividendPayersLegend: 'Дивидентен доход',
  commonDiscoverHighGrowthCompanies: 'Ръст на приходите',
  commonDiscoverHighGrowthCompaniesLegend: 'Индикатор за ръст',
  commonDiscoverInfoBoxMarketCap: 'Паз. кап.',
  commonDiscoverInfoBoxRevenue: 'Приходи',
  commonDiscoverInfoBoxEps: 'EPS',
  commonDiscoverInfoBoxVolume: 'Обем',
  commonDiscoverInfoBoxPrevQ: 'Предишно тримесечие',
  commonDiscoverInfoBoxPrevClose: 'Цена на затваряне',
  commonDiscoverInfoBoxDividendRate: 'Дивидентна ставка',
  commonGrowthIndicatorDescription: 'Средната стойност на ръста на приходите и ръста на EPS през последните 12 месеца',

  // Market Hours
  commonMarketHoursPre: 'Ранна сесия',
  commonMarketHoursAfter: 'Късна сесия',
  commonMarketHoursAtClose: 'При затваряне',
  commonMarketHoursAtClose2: 'Затваря',
  commonPreMarketHoursTradingStarting: 'Редовната пазарна сесия започва след:',
  commonMarketClosedHoursTradingStarting: 'Пазарът е затворен. Ранната сесия започва след:',

  // Trading tickets
  commonTradingOrder: 'Поръчка',
  commonTradingOrderTitle: '@@1 поръчка "@@2"',
  commonTradingOrderTitle2: 'Поръчка "@@1" за @@2',
  commonTradingOrderType: 'Тип поръчка',
  commonTradingOrderTypeShort: 'Тип',
  commonTradingOrderTypeLimit: 'Лимитирана',
  commonTradingOrderTypeStop: 'Стоп',
  commonTradingExpiryDate: 'Крайна дата',
  commonTradingSelectDate: 'Избери дата',
  commonTradingExtendedHoursTrade: 'Удължени часове за търговия',
  commonTradingOrderValue: 'Обща стойност',
  commonTradingOrderValue2: 'Обща стойност',
  commonConfirmOrderButton: 'Потвърди поръчка',
  commonConfirmOrderButton2: 'Потвърдете поръчката',
  commonExpirationOrderEndOfDaySubText: 'Поръчката ще изтече в края на деня при затварянето на пазара.',
  commonExpirationOrderGoodTillCanceledSubText: 'Поръчката ще изтече, единствено когато Вие я отмените или след 90 дни.',
  commonExpirationOrderGoodTillDateSubText: 'Поръчката ще изтече на избраната дата',
  commonHaveShortedStocksTitle: 'Затворете късите си продажби',
  commonHaveShortedStocksDescription1: 'Вие имате',
  commonHaveShortedStocksDescription1SubText1: '@@1 къси @@2',
  commonHaveShortedStocksDescription1SubText2: 'продажби.',
  commonHaveShortedStocksDescription2:
    'Трябва първо да затворите късите си продажби, преди да изпратите поръчка тип "Купи".',
  commonHaveShortedStocksDescription3: 'Ако искате да научите повете за късите продажби, последвайте линка.',
  commonTradingPriceError: 'Трябва да въведете @@1 цена за този тип поръчка',
  commonTradingAggressiveLimitPriceError: 'Цената трябва да е по-ниска от @@1',
  commonTradingAggressiveLimitPriceError1: 'Цената трябва да е по-ниска от @@1',
  commonTradingStopPriceError: 'Стоп цената трябва да е @@1 от пазарната цена.',
  commonTradingExpiryDateError: 'Трябва да въведете дата на изтичане.',
  commonTradingShortSellDialog: 'Вие изпращате поръчка за Къси продажби',
  commonRegularTradingHoursStartDialogTitle: 'Поръчка за къса продажба',
  commonTradingShortSellDialogDescription:
    'Късите продажби са стратегия за търговия за напреднали трейдъри. Трябва да имате предвид, че те са свързани с допълнителен риск и потенциални загуби.',
  commonTradingShortSellDialogDescriptionWeb: 'Късите продажби са възможни единствено по време на редовната пазарна сесия.',
  commonRegularTradingHoursStartDialogDescription:
    'Късите продажби са възможни единствено по време на редовната пазарна сесия. Редовната сесия започва след:',
  commonRegularTradingShortSellDescription: 'Моля имайте предвид, че ще бъде приложен дневен лихвен процент от @@1.',
  commonTradingLinkHere: 'линк тук.',
  commonTradingHere: 'тук.',
  commonTradingNotEnoughBuyingPowerTitle: 'Недостатъчно свободни средства',
  commonTradingNotEnoughBuyingPowerDescription: 'Нямате достатъчно свободни средства за покупката. Можете да освободите средства при затваряне на отворени позиции.',
  commonNotEnoughSharesAvailable: 'Моля, посочете по-малък брой акции',

  // Trading validation
  commonTradingValidationNewOrderEnterNumberOfShares: 'Трябва да въведете брой акции за тази поръчка.',
  commonTradingValidationNewOrderCloseBuyNumberOfShares: 'Броят на акциите не трябва да бъде по-голям от @@1',
  commonTradingValidationNewOrderEnterLimitOrStopPrice: 'Трябва да въведете @@1 цена за тази поръчка.',
  commonTradingValidationNewOrderAggressiveBuyLimitPrice: 'Цената трябва да е по-ниска от @@1.',
  commonTradingValidationNewOrderAggressiveSellLimitPrice: 'Цената трябва да е по-висока от @@1.',
  commonTradingValidationNewOrderBuyStopPrice: 'Стоп цената трябва да е по-висока от пазарната цена.',
  commonTradingValidationNewOrderSellStopPrice: 'Стоп цената трябва да е по-ниска от пазарната цена.',
  commonTradingValidationNewOrderBuyingPower: 'Нямате достатъчно средства за тази поръчка.',
  commonTradingValidationNewOrderSellAggressiveLimitError: 'Цената трябва да е по-висока от @@1',
  commonTradingValidationNewOrderSellAggressiveLimitError1: 'Цената "Продава" трябва да е по-висока от @@1',

  // Halted stock
  commonHaltedSymbolPopupTitle: 'Символът не се търгува в момента',
  commonHaltedSymbolInfo: 'Временно спрян от търговия от борсата.',
  commonHaltedSymbolPopupContent: 'В момемта не се приемат поръчки за @@1, тъй като е спрян временно от търговия.',

  // Inbox messages
  commonInboxNoMessagesText: 'Тук все още няма нищо.',
  commonInboxNoMessagesText2: 'Няма съобщения',
  commonInboxSelectedMessagesText: '@@1 избрани',
  commonInboxDeleteMessagesTitle: 'Изтрий @@1 съобщения',
  commonInboxDeleteMessagesTitle2: 'Изтрий',
  commonInboxAreYouSureYouWantToDeleteMessageText1: 'Сигурни ли сте, че искате да изтриете тези съобщения?',
  commonInboxAreYouSureYouWantToDeleteMessageText1WithNumber: 'Сигурни ли сте, че исате да изтриете @@1 съобщения?',
  commonInboxAreYouSureYouWantToDeleteMessageText2: 'Съобщенията не могат да бъдат възстановени.',

  // -----------   Web   -----------

  webLogoutIn: 'Изход',

  webMyAssetsTitle: 'Моите активи',
  webPortfolioSummaryTitle: 'Портфолио-детайли',

  // signUp
  webSignInEmailNotReceived: 'Не сте получили имейл за потвърждение? Проверете спам папката си',
  webSignInSubTitle: 'Вече имате профил?',
  webSignInButton: 'Вход',
  webSendAgain: 'Изпратете отново.',
  webResendEmail: 'Изпратете отново след: ',

  // onboarding
  webOnboardingEndScreenSubmitBtnText: 'Към плащания',

  // Trading
  webTradingMarketAskPrice: 'Пазарна / @@1 цена:',
  webTradingCurrentlyPlacedBuyOrder: 'В момента изпращате @@1 поръчка, която ще се изпълни на най-добрата @@2 цена',
  webTradingCurrentlyAskPrice: 'Настояща цена "Купува": @@1',
  webTradingCurrentlyBidPrice: 'Настояща цена "Предлага": @@1',
  webTradingLastTradePrice: 'Последна цена: @@1',
  webTradingDisclaimerPopover:
    'Цената, която показваме на нашите графики представлява цената на последната реализирана сделка на пазара. По тази причина тя може да се различава от настоящата пазарна / @@1 цена.',
  webTradingAskAndBidPricesGeneralInfo: 'Поръчки тип "Купи" ще се изпълнят на най-добрата цена "Купува", а поръчки тип "Продай" - на най-добрата цена "Предлага".',
  webTradingIncludeExtendedHoursTrading: 'Включи удължени часове за търговия',
  webTradingBuyShortedPositionsDescription1: 'Имате предишна изпратена поръчка за Къси продажби за',
  webTradingBuyShortedPositionsDescription1Subtext1: '@@1 акции',
  webTradingBuyShortedPositionsDescription1Subtext2: 'Изпълнена',
  webTradingBuyShortedPositionsDescription2: 'Преди да изпратите обикновена поръчка тип "Купува" трябва да затворите Вашите къси продажби.',
  webTradingIncorrectStocks: 'Недостатъчно налични акции. \n Моля, опитайте отново',
  webTradingShortedStocks: 'Къси продажби: @@1',
  webTradingAvailableShares: 'Притежавани: @@1',
  webTradingAsk: 'Купува',
  webTradingBid: 'Предлага',
  webTradingMore: 'повече',
  webTradingLess: 'по-малко',
  webTradingLimit: 'Лимитирна',
  webTradingStop: 'Стоп',
  webTradingHighLowLimitPriceAlert: '@@1 лимитирана цена ',
  webTradingHighLowLimitPriceAlertHigh: 'Висока',
  webTradingHighLowLimitPriceAlertHigher: 'по-висока',
  webTradingHighLowLimitPriceAlertLow: 'Ниска',
  webTradingHighLowLimitPriceAlertLower: 'по-ниска',
  webTradingHighLowLimitPriceAlertDescription:
    'Избраната от Вас лимитирана цена е @@1 от пазараната цена на акцията. Това може да доведе до незабавно изпълнение на поръчката. Искате ли да продължите?',
  webTradingEditPriceButton: 'Промени цената',

  // (1/7) order message - placed
  orderMessageTitlePlaced: '@@1 поръчка "@@2" е изпратена',
  orderMessageTitlePlaced2: '@@1 поръчка @@2 е изпратена',
  orderMessageBodyPlaced: 'Вашата поръчка за @@1 x @@2 беше изпратена',
  // (2/7) order message - filled
  orderMessageTitleFilled: '@@1 поръчка "@@2" е изпълнена',
  orderMessageTitleFilled2: '@@1 поръчка @@2 е изпълнена',
  orderMessageBodyFilled: 'Вашата поръчка за @@1 x @@2 беше изпълнена',
  orderMessageTitlePartiallyFilled: '@@1 "@@2" поръчка е частично изпълнена',
  orderMessageBodyPartiallyFilled: '@@1 / @@2 @@3 бепе изпълнена',
  // (3/7) order message - being processed
  orderMessageTitlePending: '@@1 @@2 @@3 поръчка е в изчакване',
  orderMessageBodyPending: 'Вашата поръчка за @@1 x @@2 се обработва',
  orderMessageBodyPendingWeb: 'Вашата @@1 поръчка "@@2" за @@3 x @@4 се обработва',
  orderMessageBodyPendingWeb2: 'Вашата @@1 поръчка @@2 за @@3 x @@4 се обработва',
  // (4/7) order message - rejected
  orderMessageTitleRejected: '@@1 @@2 поръчка е отказана',
  orderMessageBodyRejected: 'Вашата поръчка за @@1 x @@2 беше отказана',
  orderMessageTitlePartiallyRejectedTitle: '@@1 "@@2" поръчка е частично отказана',
  orderMessageBodyPartiallyRejectedBody: '@@1 / @@2 @@3 беше отказана',
  orderMessageBodyRejectedWeb: 'Вашата @@1 поръчка “@@2” за @@3 x @@4 беше отказана',
  orderMessageBodyRejectedWebShort: 'Вашата @@1 поръчка @@2 за @@3 x @@4 беше отказана',
  orderMessageExpired: 'Вашата @@1 @@2 поръчка за @@3 x @@4 изтече',
  // (5/7) order message - error
  orderMessageTitleError: 'Не успяхме да изпратим Вашата поръчка',
  orderMessageBodyError: '',
  // (6/7) order message - modify
  orderMessageTitleModify: 'Промени @@2 "@@3" поръчка за @@1',
  orderMessageTitleModify2: 'Промени @@1 поръчка "@@2"',
  orderMessageTitleModify3: 'Промени поръчка "@@1" за @@2',
  orderMessageTitleModify4: 'Промени поръчка @@1 за @@2',
  orderMessageTitleModify5: 'Промени @@1 поръчка @@2',
  orderMessageModifySuccessWeb: 'Вашата @@1 поръчка "@@2" за @@3 x @@4 беше променена',
  orderMessageModifySuccessWebShort: 'Промени @@1 поръчка за Къси продажби',
  orderMessageBodyModifyPending: 'Заявката за промяна на @@1 x @@2 се обработва',
  orderMessageBodyModifyPending2: 'Вашата поръчка за @@1 x @@2 беше променена',
  orderMessageBodyModifyFail: 'Заявката за промяна беше неуспешна',
  // (7/7) order message - cancel
  orderMessageTitleCancel: 'Отмени @@1 поръчка "@@2"',
  orderMessageTitleCancel2: 'Отмени @@1 поръчка @@2',
  orderMessageBodyCancelSuccess: 'Вашата поръчка за @@1 x @@2 беше отменена',
  orderMessageCancelSuccessWeb: 'Вашата @@1 @@2 поръчка за @@3 x @@4 беше отменена',
  orderMessageCancelSuccessTitle: 'Отмени @@1 поръчка "@@2"',
  orderMessageCancelSuccessBody: 'Вашата поръчка за @@1 x @@2 беше отменена',
  orderMessageCancelAccepted: 'Заяката за отмяна на поръчка е приета',
  orderMessageBodyCancelPending: 'Вашата заявка за отмяна на @@1 x @@2 се обработва',
  orderMessageBodyCancelFail: 'Заявката за отмяна беше неуспешна',

  // order popup
  webOrderPopupCancelTitle: 'Отмени поръчка',
  webOrderPopupCancelTitleLower: 'Отмени поръчка',
  webOrderPopupAreYouSureToCancelLabel: 'Сигурни ли сте, че искате да отмените поръчката?',
  webPopupCardTransferDescription1: 'картата трябва да е на Ваше име.',
  webPopupCardTransferDescription2: 'Депозити от други карти ще бъдат отказани.',
  webPopupBankTransferDescription1: 'Банковата сметка трябва да е на Ваше име.',
  webPopupBankTransferDescription2: 'Депозити от други сметки ще бъдат отказани.',
  webPopupBankDetailsDescription1: 'Процесът по верифициране може да отнеме до 3 работни дни.',
  webPopupBankDetailsDescription2: 'Можете да продължите и да депозирате средства.',
  webPopupDepositSlipDescription: 'Копие на депозитната разписка беше изпратено на Вашия имейл.',
  webAddNewBankAccountButton: 'Добавете нова банкова сметка',
  orderPopupFailResultSubTitle: 'Моля, опитайте отново.',

  popupFeeBreakdownTitle: 'Такси - детайли',
  popupFeeBreakdownCardTitle: 'Картови такси:',
  popupFeeBreakdownCardEUDebitKey: 'Дебтини / кредитни карти от ЕС',
  popupFeeBreakdownCardEUDebitValue: 'Дебитни карти: @@1',
  popupFeeBreakdownCardEUCreditValue: 'Кредитни карти: @@1',
  popupFeeBreakdownCardNonEUkey: 'Бизнес карти и карти извън ЕС',
  popupFeeBreakdownBankTitle: 'Банкови такси:',
  popupFeeBreakdownMinimumDepositKey: 'Минимален депозит',
  popupFeeBreakdownMinimumDepositValue: 'Няма минимален депозит',
  popupFeeBreakdownDescription: '*Банката Ви може да наложи допълнителни такси.',

  webFundsDividendLabel: 'Дивидент',
  webFundsTransactionsTitle: 'Трансакции',

  webAccountFundingMethod: 'Метод на депозиране',

  // ETF Trading restrictions
  etfTradingRestrictionsModalTitle: 'Огранчения за търговия с ETF-и',
  etfTradingRestrictionsModalContent: 'Пакетните продукти (ETF - и), които предлагаме в момента, нямат основен информационен документ. Само потребители, верифициарни като професионлани трейдъри, могат да търгуват с тях. Научи повее на ',
  etfTradingRestrictionsEtfURL: 'www.10n.com/ETFs',
  etfTradingRestrictionsMessage: 'Символът не може да бъде търгуван поради рестрикции за търговия с ETF - и.',
  // -----------   Mobile   -----------

  mobileCommonButtonsCancel: 'Отмени',
  mobileCommonButtonsExit: 'Изход',

  mobileFundingPickerTitle: 'Избери метод на депозиране:',
  mobilePhotoPickerTitle: 'Избери опция:',
  mobilePhotoPickerCameraAction: 'Снимай с камера',
  mobilePhotoPickerGalleryAction: 'Прикачи от галерията',

  mobileConfirmPhotoScreenFrontOfIdTitle: 'Лицето на документа достатъчно ясно и четимо ли е?',
  mobileConfirmPhotoScreenFrontOfIdSubtitle: 'Моля, уверете се, че цялата лична карта се вижда и след това прикачете гърба на документа.',
  mobileConfirmPhotoScreenBackOfIdTitle: 'Гърбът на документа достътъчно ясен и четим ли е?',
  mobileConfirmPhotoScreenBackOfIdSubtitle: 'Моля, уверете се, че цялата лична карта се вижда.',
  mobileConfirmPhotoScreenSecondaryButtonGallery: 'Изберете друг файл',

  mobileAddBankAccTitle: 'Добави банкова сметка',
  mobileAddBankAccSubtitle: 'За да верифицираме банковата Ви сметка, ни е нужно копие от банково извлечение',
  mobileAddBankAccInputBank: 'Банка',
  mobileAddBankAccInputBankCountry: 'Държава',
  mobileAddBankAccInputBicSwift: 'Bic / Swift Код',
  mobileAddBankAccInputIBAN: 'IBAN / Сметка',
  mobileAddBankAccInputCurrency: 'Валута',
  mobileAddBankAccUploadBankStatementBtn: 'Прикачи банково извлечение',

  fundsScreenTitle: 'Портфейл',
  fundsScreenFundBtn: 'Добави пари',
  fundsScreenExchangeBtn: 'Обмени',
  fundScreenActiveStatus: 'Активен',
  walletSellBySymbol: 'Продай @@1',
  walletBuyBySymbol: 'Купи @@1',
  walletCurrencyExchange: 'Обмяна на валута',
  walletExchanged: 'Обменени',
  walletFee: 'Такса',
  walletExchangeAll: 'Обмени всички',
  walletExchangeBalance: 'Баланс: @@1',
  walletExchangeExceedsBalance: 'Баланът е надхвърлен: @@1',
  walletExchangeFeeMessage: 'Приложими са таксите за валутна търговия',
  walletExchangeReviewBtn: 'Прегледай',
  walletExchangeConfirmBtn: 'Потвърди',
  walletExchangeing: 'Обмяна на валута',
  walletExchangeSuccessBuy: '@@1 @@2 купени',
  walletExchangeSuccessSell: '@@1 @@2 продадени',
  walletExchangeReject: '@@1 @@2 @@3 отказани',
  walletExchangePending: '@@1 @@2 @@3 обработва се',
  walletExchangeDataError: 'Не можем да заредим данни за валутни курсове. Моля, опитайте отново.',
  walletExchageRate: 'Курс (@@1/@@2)',
  walletNoActiveAccountPleaseContact: 'В момента не можете да изпратите заявка за теглене. Моля съвржете се с ',
  walletWithdrawalsRestricted: 'Тегленията са ограничени',
  fundScreenInActiveStatus: 'Неактивен',
  fundScreenTransfer: 'Трансфер',
  fundScreenTotalAvailableCash: 'Общо налични средства',
  fundScreenAdjustment: 'Други фин. трансакции',
  fundScreenEWallet: 'Ел. портфейл',
  fundScreenCardTransfer: 'Плащане с карта',
  fundScreenInternalTransfer: 'Вътрешен трансфер',
  fundScreenAdjustmentShortMargin: 'Лихва за къси продажби',
  fundScreenAdjustmentOvernightBorrow: 'Лихва по заем',
  fundScreenAdjustmentStockLocate: 'Локейт',
  fundScreenAdjustmentMarketData: 'Пазарни данни',
  fundScreenAdjustmentInvoice: 'Фактура',
  fundScreenTotalValue: 'Общо @@1 @@2',
  fundsCheckTheFeeBreakdown: 'За по-подробна информация виж детайли по такси',
  mobileFundsScreenAvailableCash: 'Налични средства',
  mobileFundsScreenWithdrawBtn: 'Изтегли',
  mobileFundsScreenBankAccounts: 'Банкови сметки',
  mobileFundsScreenAddBankAccountBtn: 'Добави банкова сметка',
  mobileFundsScreenRecentTransactions: 'Последни трансакции',
  mobileFundsScreenViewAllBtn: 'Виж всички',
  mobileFundsScreenTransactionDeposit: 'Депозирай',
  mobileFundsScreenTransactionWithdraw: 'Изтеггли',
  mobileFundsScreenModalTitle: 'Нужна е банкова сметка',
  mobileFundsScreenAddBankAccModal:
    'Моля, добавете банкова сметка, за да изпратите заявкз за теглене. Процесът по верифицирането й отнема до 3 работни дни.',
  mobileFundsScreenAddBankAccModalBtn: 'Добави банкова сметка',
  mobileFundsScreenBankAccPendingModal: 'Тече процес по верифициране на сметката. Това може да отнеме до 3 работни дни.',
  mobileFundsScreenSuccessCardDepositDialog: '@@1 бяха депозирани във \n Вашата сметк',
  mobileFundsScreenPendingCardDepositDialog: 'Депозитът Ви за @@1 \n се обработва',
  mobileFundsScreenFailedCardDepositDialog: 'Нещо се случи',

  mobileFundsViewAllScreenTransactions: 'Трансакции',
  mobileTransactionTypeToBankAccountHeading: 'Към банкова сметка',
  mobileTransactionTypeFromBankAccountHeading: 'От банкова сметка',
  mobileTransactionTypeLabelDetails: 'Детайли',
  mobileTransactionTypeLabelType: 'Тип',
  mobileTransactionTypeLabelPaymentRef: 'Код на плащане',
  mobileTransactionTypeLabelBank: 'Банка',
  mobileTransactionTypeLabelAccountN: 'Номер на сметка',
  mobileTransactionTypeLabelCategory: 'Категория',

  mobileWithdrawScreenTitle: 'Теглене',
  mobileWithdrawScreenSubtitle: 'Такса теглене: @@1 @@2 • Вашата банка може да наложи допълнителни такси за валутни операции и банкови трансфери.',
  mobileWithdrawScreenAvailableCash: 'Налични средства',
  mobileWithdrawScreenRequestBtn: 'Изпрати заявка за теглене',
  mobileWithdrawScreenModalTitle: 'Заяка за теглене',
  mobileWithdrawScreenModal:
    'Заявките за теглене се обработват за 1 работен ден.\n\n В зависимост от банката, която ползвате, трансферът може да отнеме до 5 работни дни.',
  mobileWithdrawScreenInfoModalTitle: 'Налични средства: @@1',
  mobileWithdrawScreenInfoModalPersonalCash: 'Лични средства: @@1',
  mobileWithdrawScreenInfoModalInstaCash: '10n незабавен кеш: @@1',
  mobileWithdrawScreenInfoModalDailyInterest: 'Дневна лихва = @@1',
  mobileWithdrawScreenInfoModalDescription:
    'Наличните средства за теглене се изчисляват в края на всеки работен ден. Те зависят от нереализираната печлба. настоящите поръчки и кешовите операции по сметката.',
  mobileWithdrawScreenBankAccount: 'Банкова сметка',

  mobileCardDialogTitle: 'Картов депозит',
  mobileCardDialogDescription: 'Картата трвбва да е на Ваше име. Депозити от други карти ще бъдат отказани',
  mobileBankDialogTitle: 'Банков депозит',
  mobileBankDialogDescription: 'Банковата сметка трвбва да е на Ваше име. Депозити от други банкови сметки ще бъдат отказани',
  mobileDepositSlipDialogTitle: 'Депозитната разписка е изпратена!',
  mobileDepositSlipDialogDescription:
    'Копие от депозитната разписка е изпратено на Вапия имейл. \n\n Кодът за плащане ще бъде валиден до',

  // Deposit Notifications
  mobileNameAndAddressVisible: 'Вашето пълно име и адрес както и наименованието на банката трябва да се виждат ясно.',
  mobileBankStatementIssuedLastThreeMonths: 'Банково извлечение, издадено през последните 3 месеца',

  mobileDepositBankAddress: 'Адрес на банката',
  mobileDepositSlipInputBank: 'Банка на получателя',
  mobileDepositSlipInputName: 'Наименование на получателя',
  mobileDepositSlipLabelPaymentCode: 'Код на плащане',
  mobileDepositSlipTitle: 'Депозитната разписка е създадена успешно',
  mobileDepositSlipSubtitle: 'Използвайте информацията по-долу за Вашето банково плащане',
  mobileDepositSlipAlert: 'Уверете се, че сте въвели този код като основвание за плащане',
  mobileDepositSlipCopyBtn: 'Копирай разписка',
  mobileDepositSlipModalTitle: 'Депозитната разписа е изпратена',
  mobileDepositSlipModalDescription: 'Копие на депозитната рзписка е изпратено на Вашия имейл',
  mobileDepositSlipCopiedMessage: 'Депозитната разписка е копирана',

  mobileBankDetailsSetTitle: 'Банковите детайли са записани!',
  mobileBankDetailsSetSubtitle1: 'Верифицирането им може да отнеме до 3 бизнес дни.',
  mobileBankDetailsSetSubtitle2: 'Можете да продължите с',
  mobileBankDetailsSetSubtitle3: 'Вашия депозит.',

  depositAmountTitle: 'Депозирай',
  depositAmountChangeMethod: 'Промени метод за депозиране',
  mobileDepositAmountSubtitle: 'Вашата банка може да наложи допълнителни такси за валутни операции и банкови трансфери.',
  mobileDepositAmountLabel: 'Сума',
  mobileDepositAmountBtn: 'Депозирай',
  mobileDepositAmountSourceOfFundBankTitle: 'Банков трансфер',
  mobileDepositAmountMinimumDepositAmount: 'Минимум депозит: @@1',
  mobileDepositAmountMaximumDepositAmount: 'Маскимум депозит: @@1',

  mobileSecurityScreenTitle: 'Сигурност',
  mobileSecurityScreenSubtitle: 'Изберете желания от вас метод за защита на профила',
  mobileSecurityTwoFactorLabel: 'Двуфакторна аутентикация',
  mobileSecurityPasscodeLabel: 'Код за достъп',
  mobileSecurityBiometricsLabel: 'Биометрични данни',
  mobileSecurityChangePasswordLabel: 'Промени парола',
  mobileSecurityChangePasscode: 'Промени код за достъп ',
  mobileSecuritySnackMessageEnabled: 'Кодът за достъп е активиран.',
  mobileSecuritySnackMessageDisabled: 'Кодът за достъп е деактивиран.',
  mobileSecuritySnackMessageUpdated: 'Кодът са достъп е променен.',
  mobileSecuritySnackMessageDontMatch: 'Кодът за достъп не съвпада.',
  mobileSecuritySnackMessageDontAvaileble: 'Няма биометрини данни.',
  mobilePasscodeAlertMessage: 'Искате ли да прекратите процеса?',
  mobileChangePasswordModalText: 'Наистина ли искате да промените паролата си?',
  mobileSecurityForgotPasscode: 'Забравена парола?',
  mobileSecurityUsePassword: 'Използвайте паролата си',

  mobilePasswordChangeEmailTitle: 'Проверете имейла си',
  mobilePasswordChangeEmailUnderlineHeading1: 'Току що изпратихме имейл на',
  mobilePasswordChangeEmailUnderlineHeading2: ' С инструкции за промяна на паролата',

  commonPassCode: 'Промени кода за достъп',

  mobileWatchlistStocks: 'Популярни',
  mobileOrdersTitle: 'Виж Поръчки',
  mobileSortButton: 'Сортирай',
  mobileWatchlistNoData: 'Няма данни',
  mobileSortByLatest: 'Най-нови',
  mobileSortByLastPrice: 'Последна цена',
  mobileSortByPercentChange: '%Промяна',

  // splash screen - N/A
  mobileSplashText: 'Alaric Trader',
  mobileSplashOfflineDemo: 'Offline Demo',

  // Passcode dialog
  mobilePasscodeEnterPasscode: 'Въведи код за достъп',
  mobilePasscodeSetup: 'Избери нов код за достъп',
  mobilePasscodeConfirm: 'Потвърди нов код за достъп',
  mobileEnterYourPasscode: 'Въведи код за достъп',
  mobilePasscodeWelcomeBack: 'Добре дошли отново. Липсвахте ни!',
  mobilePasscodeEasyAccess: 'За лесен дотъп до Вашата трейдинг сметка',

  // order create
  mobileOrderCreateTitle: 'Създай @@1 поръчка',
  mobileOrderCreateTabMarket: 'Пазарна',
  mobileOrderCreateTabLimit: 'Лимит.',
  nonMobileOrderCreateTabLimit: 'Лимитирана',
  mobileOrderCreateTabStop: 'Стоп',
  mobileOrderCreateTabStopLimit: 'Стоп-лимитирана',
  mobileOrderCreateTabPegged: 'Обвързана',
  mobileOrderCreateSymbol: 'Символ',
  mobileOrderCreateMarketPrice: 'Пазарна цена',
  mobileOrderCreateButtonReviewOrder: 'Прегледай поръчка',
  mobileOrderCreateSelectShares: 'Избери',
  mobileOrderCreateTargetPrice: 'Целева цена',
  mobileOrderCreateTimeInForce: 'Време за изпълнение',
  mobileOrderCreateValue: 'Стойност',
  mobileOrderCreateAvailableBuyingPower: 'Свободни средства',
  mobileOrderCreateCommission: 'Комисион',
  mobileOrderCreateCommissionFree: 'Без',
  mobileOrderCreateCost: 'Обща стойност',
  mobileOrderCreateBuyingPower: 'Свободни средства',
  mobileOrderCreateStopMessage: 'Посочете цена над настоящата, която ще превърне Вашата поръчка в пазарна.',
  mobileOrderCreateLimitMessage: 'Посоченте максималната цена, която сте готови да платите за една акция.',
  // order review
  mobileOrderReviewTitle: 'Прегледай поръчка',
  mobileOrderReviewMessage: 'Цената на силно волатилните акции може да се различава по време на изпълнение на поръчката',
  mobileOrderReviewButtonSubmit: 'Изпрати',
  mobileOrderReviewButtonCancel: 'Отмени',
  mobileOrderReviewNoPriceError: 'Цената не е налична.\nПазарът е затворен или има проблем с връзката.',
  // order popup
  mobileOrderPopupGoToPortfolio: 'Отиди на портфолио',
  mobileOrderPopupGoToOrders: 'Отиди на поръчки',
  mobileOrderPopupOrderSatus: 'Поръчка @@1',
  // view orders
  mobileOrdersViewTabPlaced: 'Изпратена',
  mobileOrdersViewTabCanceled: 'Отменена',
  // order details
  mobileOrderDetailsTitle: 'Детайли за поръчката',
  mobileOrderDetailsType: 'Тип',
  mobileOrderDetailsCreatedAt: 'Създадена на',
  mobileOrderDetailsUpdatedAt: 'Променена на',
  mobileOrderDetailsStatus: 'Статус',
  mobileOrderDetailsPrice: 'Цена',
  mobileOrderDetailsEnteredQuantity: 'Брой',

  // portfolio
  mobilePortfolioTitle: 'Портфолио',
  mobilePortfolioAvg: 'Ср.: @@1',
  mobilePortfolioYourStocks: 'Твоите акции',
  mobilePortfolioAccountValue: 'Стойност на акаунта',
  portfolioValue: 'Стойност на портфолиото',

  // account
  mobileAccountTitle: 'Акаунт',
  mobileAccountTotalValue: 'Обша стойност',
  mobileAccountBuyingPower: 'Свободни средства',
  mobileAccountFundAccount: 'Депозирай',
  mobileAccountWithdrawal: 'Теглене',
  mobileAccountTotalValueBreakdownCash: 'Кеш',
  mobileAccountTotalValueBreakdownTitle: 'Обша стойност - детайли',
  mobileAccountTradeOperations: 'Операции',
  mobileAccountViewOrders: 'Виж Поръчки',
  mobileAccountTradeTransactionHistory: 'История на сделките',
  mobileAccountTradeTransactionHistoryExecuted: 'Изпълнена',
  commonMainAccountTitle: 'Главна',
  commonBonusAccountTitle: 'Бонус',
  commonMainAccountSubscribe: 'Абонирайте се',
  commonMainAccount: 'Главна сметка',
  commonBonusAccount: 'Бонус сметка',
  commonAccountsTitle: 'Сметка:',
  commonAccountSelection: 'Избор на сметка:',
  commonActivateBonusAccount: 'Активирайте Бонус сметка',
  commonActivateBonusAccountDesc: 'Абонирайте се за “Капитал”, за да получите Бонус сметка и удвоите шанса си да спечелите',
  commonActivateBonusAccountSwitch: 'Смени сметка',

  // Trade History
  commonTradeHistoryNoTradeIn90Days: 'Нямате сделки за последните 90 дни.',
  commonTradeHistoryNothingHere: 'Тук няма нищо',
  commonTradeHistoryDetailsPrice: '@@1 цена',

  // profile
  mobileProfileHeaderTitle: 'Профил',
  mobileProfileVersion: 'Версия',
  mobileProfileBuild: 'build',
  mobileProfileTitle: 'Здравей @@1!',
  mobileProfileAccountSettingsTitle: 'Настройки',
  mobileProfilePersonalDetails: 'Лични данни',
  mobileProfileNotificationSettings: 'Настройки за нотификации',
  mobileProfileDocuments: 'Документи',
  mobileProfileChangePassword: 'Промени парола',
  mobileProfileChangePasscode: 'Промени код за достъп',
  mobileProfileDeviceSettings: 'Настройки на устройството',
  mobileProfileFingerprint: 'Пръстов отпечатък',
  mobileProfileSupportCenter: 'Съпорт',
  mobileProfileHelp: 'Връзка с нас',
  mobileProfileGuides: 'Наръчници',
  mobileProfileOptionsAndETFsActivations: 'Активация на опции и ETF-и',
  mobileProfileSettings: 'Настройки',
  mobileEditProfileResidentialAddress: 'Промени адрес',
  mobileEditProfileIDDocument: 'Промени Документ за самоличност',
  mobileEditProfileName: 'Промени име',

  // New Profile
  mobileProfileMyProfile: 'Моят профил',
  mobileProfileInbox: 'Пощ. кутия',
  mobileProfileInboxDescription: 'Системни съобщени и ъпдейти',
  mobileProfilePersonalInformation: 'Лична информация',
  mobileProfilePersonalInformationDescription: 'Лични данни и данни за контакт. Адрес',
  mobileProfileSecurity: 'Сигурност',
  mobileProfileSecurityDescription: 'Парола. Код за достъп. Биометрични данни',
  mobileProfileMyReports: 'Отчети',
  mobileProfileMyReportsDescription: 'вашите месечни отчети',
  mobileProfileMyNotifications: 'Известия',
  mobileProfileMyNotificationsDescription: 'Предпочитания',

  commonProfileMySupportCenter: 'Контакт с нас',
  commonProfileMySupportCenterDescription: 'Съпорт & ЧЗВ',
  commonProfileTradeHistoryDescription: 'Трейдинг история и активности',
  commonProfileDocumentsDescription: 'Обши условия, тарифи и др.',

  // tips & notifications - N/A
  mobileProfileTipsAndNotificationsTitle: 'Tips & Notifications',
  mobileProfileTipsAndNotificationsPushNotification: 'Push notification',
  mobileProfileTipsAndNotificationsTips: 'Tips',
  mobileProfileTipsAndNotificationsMarketingMessages: 'Marketing messages',
  mobileProfileTipsAndNotifications: '',

  // inbox
  mobileInboxTitle: 'Пощ. кутия',
  mobileInboxBegin: 'Начало',
  mobileInboxEnd: 'Край',

  // charts
  mobileChartInterval: '1д,1с,1м,3м,1г,5г',

  // set passcode
  mobileSetPasscodeSetupYourPasscode: 'Въведете код за достъп',
  mobileSetPasscodePleaseConfirm1: 'Моля',
  mobileSetPasscodePleaseConfirm2: 'Потвърдете Вашия код за достъп',
  mobileSetPasscodeDescription: 'Така активирате допълнително ниво на сигурност и по-лесен достъп',
  mobileSetPasscodeResend: 'Изпрати отново',

  // onboarding
  mobileOnboardingSignUp: 'Регистрирайте се',
  mobileOnboardingLogIn: 'Вход',
  mobileOnboardingAlreadyHaveAccount: 'Вече имате профил?',
  mobileOnboardingPhotoIsClearButton: 'Прикачи и продължи',
  mobileOnboardingUploadConfirmTitle: 'Ясна ли е снимката?',
  mobileOnboardingUploadRetakeButton: 'Снимай отново',
  mobileOnboardTextIsClear: 'Да, ясна е',

  // news
  mobileNewsBrokenLinkTitle: 'Счупена връзка',
  mobileNewsBrokenLinkMessage: 'Тази статия няма URL линк. Моля, уведомете ни това.',
  newsTechnicalIssueMessage: 'В момента има технически проблем. Опитайте отново по-късно',

  // stock search
  mobileStocksLabel: 'Акции',
  mobileNoStocksFound: 'Няма намерени акции',
  commonNoETFsFound: 'Няма намерени ETF-и',
  mobileStockSearchLoading: 'Зареждане на списъка с акции',
  mobileStockSearchHint: 'Търси акции...',
  mobileStockSearchDescription: 'Търси по символ или компания',

  // industry search
  mobileIndustrySearchLoading: 'Зарежда се ....',
  mobileIndustrySearchPlaceholder: 'Търси...',

  // watchlist when not activated
  mobileWatchlistActivationBoxTitle: 'Активирайте профила си!',
  mobileWatchlistActivationBoxDescription: 'Продължете със следващите стъпли: верификация и депозит. След това ще можете да търгувате.',
  mobileWatchlistActivationBoxDescriptionRow1: 'Продължете със следващите стъпли: верификация и',
  mobileWatchlistActivationBoxDescriptionRow2: 'депозит. След това ще можете да търгувате.',

  // Make your first deposit
  commonFirstSkipDepositTitle: 'Прппусни',
  commonFirstDepositTitle: 'Направи първи депозит',
  commonFirstDepositDescription1: 'Минимален депозит :',
  commonFirstDepositDescription2: '@@1 или еквивалента във Вашата валута',
  commonFirstDepositBank: 'Банков депозит',
  commonFirstDepositBankDescription: 'До 6 работни дни',
  commonFirstDepositCard: 'Дебитна/Кредитна карта',
  commonFirstDepositCardFree: 'Трансакционни такси - до @@1 от депозита',
  commonFirstDepositCardInstant: 'До минути',

  // Top Gainers and Losers, Movers
  commonEpicMoversToday: 'Топ изменения днес',
  commonEpicMoversDescription: 'Акции с най-голяма промяна в цената в техния ценови диапазон.',
  commonTopMovers: 'Топ изменения',
  commonTopGainers: 'Печеливши',
  commonTopGainersAndLosersMarketCap: 'Пазарна капитализация',
  commonTopGainersAndLosersPercentChange2: '% Промяна',
  commonTopGainersAndLosersPercentChange: '% Промяна',
  commonTopGainersAndLosersPriceRange: 'Ценови диапазон',
  commonTopGainersAndLosersPriceRangeFilter: 'Ценови диапазон: $@@1 to $@@2',
  commonTopGainersAndLosersPriceRangeFilterOver: 'Ценови диапазон: над $@@1',
  commonTopGainersAndLosersReset: 'Филтър по подразбиране',
  commonTopGainersAndLosersTradeVolume: 'Обем',
  commonTopGainersFilterBy: 'Филтрирай:',
  commonTopLosers: 'Губещи',
  commonEpicMoversGainers: 'Печеливши',
  commonEpicMoversLosers: 'Губещи',
  commonEpicMoversLastPriceChanges: 'Последна/ %Промяна',
  commonEpicMoversDaily52Wk: 'Днес / 52с.',
  commonEpicMoversSymbolName: 'Символ/Компания',
  commonWeek52GainersAndLosers: '52-седмични изменения',
  commonWeek52GainersAndLosersStockMakingHighLow: 'Акции с нова най-висока / най-ниска цена за последните 52 седмици',

  // Trading tickets
  mobileTradingTicketBuy: 'Купи',
  mobileTradingTicketSell: 'Продай',
  mobileTradingTicketOrderType: 'Тип поръчка',
  mobileTradingTicketChangeOrderType: 'Промени тип поръчка',
  mobileTradingTicketSelectOrderType: 'Избери тип поръчка',
  mobileTradingTicketNumberOfShares: 'Брой акции',
  mobileTradingTicketShortedStocks: 'Притежавани:',
  mobileTradingTicketMarketPrice: 'Пазарна цена',
  mobileTradingTicketMarketOrder: 'Пазарна поръчка',
  mobileTradingTicketSellMarketOrder: 'Пазарна поръчка "Продай"',
  mobileTradingTicketBuyMarketOrder: 'Пазарна поръчка "Купи"',
  mobileTradingTicketLimitPrice: 'Лимитирана цена',
  mobileTradingTicketLimitOrder: 'Лимитирана поръчка',
  mobileTradingTicketStopPrice: 'Стоп цена',
  mobileTradingTicketStopPrice2: 'Стоп цена',
  mobileTradingTicketStopOrder: 'Стоп поръчка',
  mobileTradingTicketReviewOrder: 'Прегледай поръчката',
  mobileTradingTicketEstimatedOrderValue: 'Обща стойност',
  mobileTradingTicketBuyingPower: 'Свободни средства',
  mobileTradingTicketNotice: 'Моля, имайте предвид, че лихвените проценти ще бъдат начислени на следващия трейдинг ден',
  mobileTradingTicketExecutedAtBestAvailablePrice: 'Изпълнява се на най-добрата налична цена',
  mobileTradingTicketExecutedAtLimitPriceOrLover: 'Изпълнява се на лимитираната или по-добра цена',
  mobileTradingTicketExecutedWhenStopPriceIsReached: 'Изпълнява се, когато стоп цената е достигната',
  mobileTradingTicketNotEnoughBuyingPower: 'Нямате достатъчно свободни средства',
  mobileTradingTicketNotEnoughBuyingPowerDescription: 'Нямате достатъчно свободни средства за покупката. Можете да освободите средства при затваряне на отворени позиции.',
  mobileTradingTicketYouHaveSuccessfullyPlacedLimitOrder: 'Успешно изпратихте лимитирана поръчка',
  mobileTradingTicketYouHaveSuccessfullyPlacedMarketOrder: 'Успешно изпратихте пазарна поръчка',
  mobileTradingTicketYouHaveSuccessfullyPlacedStopOrder: 'Успешно изпратихте стоп поръчка',
  mobileTradingTicketYourOrderWasSuccessfullyPlaced: 'Поръчката Ви беше успешно изпратена',
  mobileTradingTicketDateOfExpireTitle: 'Посочете крайна дата',
  mobileTradingTicketDateOfExpireHowLong: 'Колко дълго поръчката Ви ще стои отворена преди да бъде изпълнена?',
  mobileTradingTicketDateOfExpireMaxDaysOrderValid: 'Максималният брой дни, за които е валидна Вашата поръчка',
  mobileTradingTicketDateOfExpireEndOfDay: 'Валидна за деня',
  mobileTradingTicketDateOfExpireEndOfDayShort: 'За деня',
  mobileTradingTicketDateOfExpireGoodTillCancelled: 'Валидна до отмяна (GTC)',
  mobileTradingTicketDateOfExpireGoodTillCancelledShort: 'Валидна до отмяна',
  mobileTradingTicketDateOfExpireGoodTillDate: 'Валидна до дата',
  mobileTradingTicketYourOrderRejected: 'Вашата поръчка беше отказана',
  mobileTradingTicketCurrentAskPrice: 'Настояща цена "Купува":',
  mobileTradingTicketCurrentBidPrice: 'Настояща цена "Предлага":',
  mobileTradingTicketLastTradePrice: 'Последна цена:',

  commonTradeHistoryTitle: 'Трейдинг история',
  tradingMarketLastTradePrice: 'Пазарна цена / Последна цена: @@1',

  // Stock screen
  mobileStockScreenChartTitle: 'Графика',
  mobileStockScreenPeopleAlsoTradeItemTitle: 'Графика',
  mobileStockScreenStockTileToday: 'Днес',

  // Shares Owned
  commonHistory: 'История',
  commonSharesOwned: 'Притежавани',
  commonShort: 'Къса',
  commonShort2: 'Къси',
  commonViewHistory: 'Виж история',
  commonTitleHistory: 'Трейдинг история',
  commonQtAvgPrice: 'Брой / Ср. цена',
  commonPL: 'Печалба',
  commonValue: 'Стойност',
  commonYouHaveTraded: 'С този символ е търгувано през последните 90 дни.',
  commonNA: 'N/A',

  // Pending Orders
  commonPendingOrders: 'Висящи поръчки',

  // Order summary
  commonOrderNo: 'Поръчка №',
  commonOrderDate: 'Дата на поръчка',
  commonMarketSell: 'Пазарна порчъка "Продай"',
  commonMarketBuy: 'Пазарна поръчка "Купи"',
  commonMarketLimitBuy: 'Лмиитрина поръчка "Купи"',
  commonMarketLimitSell: 'Лимитирна поръчка "Продай"',
  commonExpirationDate: 'Крайна дата',
  commonCancelationDate: 'Дата на отмяна',
  commonBoughtShares: 'Закупени акции',
  commonSoldShares: 'Продадени акции',
  commonFilledPrice: 'Цена на брой',
  commonFilledDate: 'Дата на ',
  commonPAndL: 'Печалба',
  commonRegulatoryFees: 'Регулаторни такси',
  commonViewDetailedReport: 'Виж детайлен отчет',
  commonCancelOrder: 'Отмени поръчка',
  commonModify: 'Промени',
  commonModifyOrder: 'Промени поръка',
  commonChart: 'Графика',
  commonPercentChange: '%Промяна',

  commonRegulatoryFeesMessage: 'Регулаторни такси: @@1 \n Това са задължителни такси за търговия, \n които се събират от FINRA и SEC \n\n FINRA такса (TAF): @@2 \n 0.000119 долара от всяка продажба на акция \n SEC такса: @@3 \n\n 0.021 долара от всяка продажба на стойност 1 000 долара',
  commonRegulatoryFeesMessageFINRA: 'FINRA такса (TAF): @@1',
  commonRegulatoryFeesMessageFINRADesc: '@@1 от всяка продажба на акция',
  commonRegulatoryFeesMessageSEC: 'SEC такса: @@1',
  commonRegulatoryFeesMessageSECDesc: '@@1 от всяка продажба на стойност 1 000 долара',
  commonRegulatoryFeesMessageTotal: 'Общо: @@1',

  // My Position
  commonMyPosition: 'Твоята позиция',
  commonMyPositionPrizeFund: 'Награден фонд: @@1',
  commonMyPositionSeeRules: 'Виж правилата',
  commonMyPositionTournamentEndsAs: 'Край на турнира: @@1',
  commonMyPositionYou: 'Вие',
  commonMyPositionProfit: 'Печалба',
  commonMyPositionChange: '% Промяна',
  commonMyPositionAward: 'Награда',
  commonMyPositionRanking: 'Класиране',
  commonMyPositionThanksForParticipating: 'Благодарим за участието в първия по рода си трейдинг турнир на Капитал!',
  commonMyPositionPrizes: '@@1 Награди',
  commonMyPositionTournamentEnded: 'Турнирът завърши!',
  commonMyPositionFollowTournament: 'При започване на турнира, можете да следите класирането тук.',
  commonMyPositionTournamentRules: 'Правила на турнира',
  commonMyPositionTournamentRegistration: 'Участие и Регистрация',
  commonMyPositionTournamentRegistrationItem1: 'Турнирът е отворен за всички регистрирани потребители на платформата.',
  commonMyPositionTournamentRegistrationItem2: 'Участниците трябва да се регистрират за турнира преди началната дата',
  commonMyPositionTournamentPeriod: 'Период на Турнира',
  commonMyPositionTournamentPeriodItem1: 'Турнирът започва на [@@1] и завършва на [@@2].',
  commonMyPositionTournamentPeriodItem2: 'Всички транзакции и търговски дейности трябва да бъдат извършени в този период',
  commonMyPositionTournamentCommercialActivities: 'Търговски Активности',
  commonMyPositionTournamentCommercialActivitiesItem1: 'Участниците могат да търгуват с акции, налични на платформата.',
  commonMyPositionTournamentCommercialActivitiesItem2: 'Не се разрешават манипулативни практики или злоупотреби.',
  commonMyPositionTournamentEvaluation: 'Оценка на Резултатите',
  commonMyPositionTournamentEvaluationItem1: 'Резултатите се оценяват въз основа на нетната печалба/загуба на края на турнира.',
  commonMyPositionTournamentEvaluationItem2: 'За да бъдат взети предвид, всички транзакции трябва да бъдат завършени до края на турнира.',
  commonMyPositionTournamentAwards: 'Награди',
  commonMyPositionTournamentAwardsItem1: 'Наградният фонд ще бъде разпределен както следва: [@@1].',
  commonMyPositionTournamentAwardsItem2: 'Победителите ще бъдат обявени на [@@1].',
  commonMyPositionTournamentCompliance: 'Спазване на Правилата',
  commonMyPositionTournamentComplianceItem1: 'Всеки участник трябва да спазва правилата на турнира и условията на платформата.',
  commonMyPositionTournamentComplianceItem2: 'Нарушения на правилата могат да доведат до дисквалификация.',
  commonMyPositionTournamentChanges: 'Промени и Отмяна',
  commonMyPositionTournamentChangesItem1: 'Организаторите си запазват правото да променят правилата или да отменят турнира при непредвидени обстоятелства.',

  // My Account
  commonMyAccount: 'Акаунт',
  commonMyAccountChargeTypeTitle: 'Тип графика',
  commonMyAccountTotalValueTitle: 'Обша стойност',
  commonMyAccountPLTitle: 'Печалба',
  commonMyAccountPastYearLabel: 'Минала година',
  commonMyAccountBuyingPowerLabel: 'Свободни средства:',
  commonMyAccountNoStocks: 'Все още нямате акции.',
  commonMyAccountNoOrders: 'Все още нямате поръчки.',
  commonMyAccountNoSharesYet: 'Все още нямате акции.',
  commonMyAccountNoStocksMessage1: 'Виж пазараните скенери и ',
  commonMyAccountNoStocksMessage2: 'намери точните акции за теб.',

  commonMyAccountButtonMyStocks: 'Моите акции',
  commonMyAccountButtonPendingOrders: 'Висящи поръчки',
  commonMyAccountButtonAccountBreakdown: 'Портфейл - детайли',
  commonMyAccountPendingOrdersPartiallFill: 'Частично изпълнена',
  commonMyAccountPendingOrdersPartialReject: 'Частично отказана',
  commonMyAccountPendingOrdersExtHours: 'Удълж. часове',

  commonAccountBreakdown: 'Детайли за акаунта',
  commonAccountBreakdownCashToInvest: 'Кеш',
  commonAccountBreakdownUsed: 'Използван',
  commonShortSell: 'Къси продажби',
  commonShortSell2: 'за къси продажби',
  commonShortSell3: 'за Къси продажби',
  commonAccountBreakdownAvailable: 'Наличен',
  commonAccountBreakdownInvestments: 'Инвестиции',
  commonAccountBreakdownUnrealizedProfit: 'Текуща печалба',
  commonAccountBreakdownProfitFromInvestedCache: 'Пвчалба от инвестирания кеш',
  commonAccountBreakdownProfitFromShortedStocks: 'Печалба от къси продажби',
  commonAccountBreakdownProfitIfYouWouldLikeToLearnMore: 'Ако желаете да научите повече за късите продажби,',
  commonAccountBreakdownProfitPressHere: 'Натиснете тук',
  commonAccountBreakdownBorrowedFunds: 'Инвестиционен заем',
  commonAccountBreakdownBorrowedFundsMargin: 'Инвестиционен заем (марджин)',
  commonAccountBreakdownTotalAmountAvailableToBorrow: 'Общата стойност, която можете да заемете, е до @@1 пъти от вашите средства.',
  commonAccountBreakdownYourDailyInterestForBorrowedFunds: 'Дневният лихвен процент за Вашия инвестиционен заем е: ',
  commonAccountBreakdownTotalStockValue: 'Обща стойност',
  commonAccountBreakdownShortedStockValue: 'Обща стойност Къси',
  commonAccountBreakdownMakeInvestmentToTrackProtfolioMsg: 'Тук можете да следите как се представя акаунта Ви по отделни пера.',
  commonAccountBreakdownTotal: 'Общо',
  commonAccountBreakdownLong: 'Дълги',
  commonAccountBreakdownPieChartStocks: '@@1 Акции',
  commonAccountBreakdownPieChartElementShare: 'Дял @@1%',

  // headers account breakdown
  headerAccountBreakdownSymbolName: 'Символ / Компания',
  headerAccountBreakdownQuantity: 'Брой',
  headerAccountBreakdownOpenValue: 'Обща стойност',
  headerAccountBreakdownMarketValue: 'Пазарна стойност',

  // headers earnings calendar
  headerEarningsCalendarEarningsCallTime: 'Обявяване',
  headerEarningsCalendarEarningsPrevEPS: 'Предишен EPS',
  headerEarningsCalendarEarningsEPSEstimate: 'EPS прогноза',
  headerEarningsCalendarEarningsEPSEst: 'EPS пр-за',

  // headers trade history
  headerTradeHistoryFillPrice: 'Цена на брой',
  headerTradeHistoryAmount: 'Обща стойност',

  // Buttons account breakdown table
  accountBreakdownTableOtherButton: 'Друго',
  accountBreakdownTableStockLabel: 'символи',

  // Inbox
  commonInboxTitle: 'Съобщения',
  commonInboxMarkAllAsRead: 'Отбележи прочетени',
  commonInboxSubject: 'Тема',
  commonInboxShowLess: 'Покажи по-малко',

  // Documents
  commonStatements: 'Statements',
  commonClientAgreement: 'Клиентски договор',
  commonGeneralTermsAndConditions: 'Общи условия и политки',
  commonOrderExecutionPolicy: 'Order Execution Policy',
  commonRiskWarningDisclosureAndNotice: 'Risk Warning Disclosure and Notice',
  commonConflictsOfInterestSummary: 'Conflicts of Interest Summary',
  commonClientCategorizationNotice: 'Client Categorization Notice',
  commonComplaintsHandlingPolicy: 'Complaints Handling Policy',
  common10NTariff: '10n тарива',
  commonTariff: 'Тарифа',
  commonDownloadingFile: 'Файлът се сваля...',

  // Notification Settings - N/A
  commonMyStocksAndOrders: 'My Stocks and orders',
  commonEverythingAboutYourTradingActivity: 'Everything about your trading activity:',
  commonOrderIsFilledCancelledOrRejected: 'Order is filled, cancelled or rejected, etc.',
  commonPushNotification: 'Push Notification.',
  commonFundsMovement: 'Funds movement',
  commonFundsMovementDescription: 'Changes to your funds and all transfers in and out as well as their current status',
  commonMyAccountStatus: 'My Account status',
  commonMyAccountStatusDescription: 'Changes in margins, funds warnings, etc.',
  commonBenefitsAndPromotions: 'Benefits and Promotions',
  commonBenefitsAndPromotionsDescription: 'Referral updates and ways to enhance your 10n experience',

  // My Profile / Personal Details
  commonPersonalDetails: 'Лични данни',
  commonNames: 'Имена',
  commonEditNames: 'Редактирай',
  commonEditNamesMultiple: 'Редактирайте',
  commonCancelMultiple: 'Откажете',
  commonMiddleName: 'Средно име',
  commonContactDetails: 'Данни за контакт',
  commonContactEditContactDetails: 'Редактирай',
  commonEdit: 'Редактирай',
  commonAddresses: 'Адреси',
  commonEditAddresses: 'Редактирай',
  commonResidential: 'Адрес по местообитание',
  commonResidentialAddress: 'Адрес по местообитание',
  commonMailing: 'Адрес за кореспонденция',
  commonMailingAddress: 'Адрес за кореспонденция',
  commonSameAsResidentialAddress: 'съвпада с адреса по местообитание',
  commonSameAsMailingAddress: 'съвпада с адреса за кореспонденция',
  commonPersonalDetailsContactUsDescription: 'Ако желаете да промените някои от данните си за контакт, моля,',
  commonPersonalDetailsContactUsButton: 'свържете се с нас.',

  // Account Deletion
  accountDelitionPart1: 'Ако желаете профилът и сметката Ви да бъдат изтрити, посетете',
  accountDelitionPart2: 'раздела Политика за поверителност',
  accountDelitionPart3: 'на нашия уебсайт.',

  // PEP Questions
  commonCheckYesIfApplicable: 'Отбележете с "Да", ако се отнася за Вас',

  // Common validations
  validationMessageInvalidCharacters: '@@1 съдържа невалидни символи',
  validationMessageMinCharacters: '@@1 трябва да е поне @@2 символа',
  validationMessageMaxCharacters: '@@1 не трябва да е повече от @@2 символа',
  validationMessageStartWithInvalidChar: '@@1 започва с невалиден символ',
  validationCapitalMinimumSymbols: 'Минимален брой символи @@1',
  validationCapitalMaximumSymbols: 'Максимален брой символи @@1',
  validationCapitalInvalidNumber: 'Невалиден номер',
  validationInputIsMandatory: 'Полето е задължително',

  // My Account - net income cmponents chart
  performanceRangeTextToday: 'днес',
  performanceRangeTextPastMonth: 'минал месец',
  performanceRangeTextPastThreeMonths: 'последни 3 месеца',
  performanceRangeTextPastYear: 'минала година',
  performanceRangeTextPastYearToDate: 'От 01 Януари @@1',
  performanceRangeTextAll: 'от @@1',

  // Date range error message
  dateRangeMaxDateErrorMessage: 'Датата не трябва да бъде по-късна от @@1',
  dateRangeMinDateErrorMessage: 'Датата не трябва да бъде по-ранна от @@1',

  // Symbol details screen
  positionAverageOpenPrice: 'Покупна цена',
  positionAUnrealisedProfitValue: 'Текуща печалба (USD)',
  positionAUnrealisedProfitPercent: 'Текуща печалба (%)',

  // MyProfile mobile screen
  myProfilePersonalDetails: 'Лични данни',
  myProfileReports: 'Отчети',
  myProfileTradingHistory: 'Трейдинг история',
  myProfileDocuments: 'Документи',
  myProfileSecurity: 'Сигурност',
  myProfileHelpCenter: 'Връзка с нас',
  myProfileLogout: 'Изход',

  // Trading View Chart
  tradingViewChartPopupMessage: 'Технически анализ',
  tradingViewChartLabel: 'Техн. анализ',

  // Hammer Login Page
  hammerLoginTitle1: 'Инвестирайте виртуално, печелете реално',
  hammerLoginTitle2: 'Регистрирайте се и отворете сметка',
  hammerLoginTitle3: 'Търгувайте като професионалист',

  hammerLoginDescription1: '“Капитал” в партньорство с “Аларик Секюритис” организира борсова игра, в която може да изпробвате инвестиционните си умения с виртуална сметка от $100,000 и да спечелите реални награди.',
  hammerLoginDescription2: 'Регистрирайте се и отворете демо сметка в няколко лесни стъпки.',
  hammerLoginDescription3: 'Най-добрите американски акции, удължени часове за търговия, къси продажби, управление на портфолиото и още много възможности.',
  hammerLoginDescription4: 'Най-добрите американски акции, удължени часове за търговия, къси продажби, управление на портфолиото и още много с 0% комисион.',

  hammerLoginPolicyAgreement: 'Вашите данни ще бъдат обработени в съответствие с. ',

  // Hammer ETFs
  etfTradingRestrictionsModalContentHW: 'Пакетните продукти (ETF-и), които предлагаме, нямат Основни Информационни документи (ОИД). Те могат да бъдат продавани и купувани от потребители със статут на професионални търговци',

  // Hammer Activation box
  activeYourAccountContent: 'След като профилът ви е верифициран можете да направите първи депозит и да започнете да търгувате.',
  walletAtivationModalContent: 'Профилът ви е в процес на верифициране. Ще ви уведомим, когато всичко е готово.',

  // Reports
  reportsSummary: 'Резюме',
  reportsExecutiveSummary: 'Резюме',
  reportsSelectOption: 'Избери опция',
  reportsChooseDate: 'Избери дата',
  reportsChooseFormat: 'Избери формат на отчета',
  reportsFileFormat: 'Формат',
  reportsDownloadButton: 'Изтегли отчет',
  reportType: '@@1 отчет',
  reportsChooseDateMaxDays: 'Избери период от максимум @@1 дни',
  reportsNoData: 'Няма данни за избрания период.',

  totalBySymbol: 'Отчет по символи',
  totalByDate: 'Отчет по дати ',
  summaryByDate: 'Обобщен отчет по дати',
  detailedReport: 'Детайлен отчет на сделките',
  feesByDestination: 'Такси по източници',
  adjustments: 'Движения по сметка',
  fees: 'Такси',
  category: 'Категория',
  comment: 'Коментар',

  totalBySymbolDescription: 'Всички данни за търгуваните символи',
  totalByDateDescription: 'Всички данни за търговията за периода',
  summaryByDateDescription: 'Отчет за дневното представяне',
  detailedReportDescription: 'Подробни данни за търговията за деня',
  feesByDestinationDescription: 'Детайлен отчет за таксите',
  adjustmentsDescription: 'Всички финансови движения по сметката',

  startingBalance: 'Start Balance',
  endBalance: 'End Balance',
  tradingFeesSummary: 'Trading Fees Summary',
  totalTradingFees: 'Total Trading Fees',
  feesSummary: 'Fees Summary',
  symbolAsset: 'Symbol: @@1      Asset: @@2',
  destination: 'Destination: @@1',
  depositsWithdrawalsAndTransfers: 'Deposit, Withdrawals & Transfers',
  totalforAllSymbols: 'Total for all symbols',
  generatedOnDate: 'Generated on @@1',
  reportTotals: 'Totals',
  reportDailyInterest: 'Daily Interest',
  reportMISC: 'MISC',
  reportSoftware: 'Software',

  // Report table headers - N/A
  currencyHeader: 'Currency',
  cashHeader: 'Cash',
  unrealizedPnlHeader: 'Unrealized PnL',
  totalHeader: 'Total',
  totalFeesHeader: 'Total Fees',
  totalBalanceHeader: 'Total Balance',
  ordersHeader: 'Orders',
  fillsHeader: 'Fills',
  qtyHeader: 'Qty',
  qtyBoughtHeader: 'Qty. Bought',
  qtySoldHeader: 'Qty. Sold',
  valueBoughtHeader: 'Value Bought',
  valueSoldHeader: 'Value Sold',
  grossHeader: 'Gross',
  commHeader: 'Comm',
  commAmountHeader: 'Comm Amount',
  commRateHeader: 'Comm Rate',
  commValuePercentHeader: 'Comm Value %',
  tradingFeesHeader: 'Trading Fees',
  nonTradingFeesHeader: 'Non-Trading Fees',
  netHeader: 'Net',
  ecnHeader: 'Ecn',
  ecnfeeHeader: 'ecnFee',
  tafHeader: 'taf',
  secHeader: 'sec',
  clrHeader: 'clr',
  prfHeader: 'prf',
  nsccHeader: 'nscc',
  efttHeader: 'eftt',
  depositsHeader: 'Deposit',
  withdrawalsHeader: 'Withdrawal',
  transferInHeader: 'Transfer In',
  transferOutHeader: 'Transfer Out',
  liquidityHeader: 'Liquidity',
  typeHeader: 'Type',
  amountHeader: 'Amount',
  rateHeader: 'Rate',
  valuePercentHeader: 'Value %',
  contraHeader: 'Contra',
  lessThan1Header: '<$1.00',
  creditHeader: 'Credit',
  debitHeader: 'Debit',
  timeHeader: 'Time',
  orderIdHeader: 'Order ID',
  fillIdHeader: 'Fill ID',
  routeHeader: 'Route',
  liqHeader: 'Liq',
  positionsHeader: 'Positions',
  assetsHeader: 'Assets',

  // Gappers
  gapperAboveClose: 'Повишение',
  gapperBelowClose: 'Намаление',
  gapperInfo: 'Акциите с над 5% изменение в цената при отварянето на пазара днес',
  gappersTitle: 'Горещи акции',
  gappersTitleGapUp: 'Повишение',
  gappersTitleGapDown: 'Намаление',
  gappersTrackEveryStock: 'Вижте всички символи с голямо изменение в цената',
  gappersHottestMoversOpenTimer: 'Вижте най-горещите символи при отварянето на пазара след:',
  gappersHottestNoData: 'В момента няма данни',

  // FX
  fxMaintenance: 'Текуща профилактика на системата',
  fxExchangeAvailableIn: 'Услугата за обмяна на валута ще бъде налична след: ',
  fxHammerExchangeDowntime: 'The currency exchange service is live from Monday till Friday with a downtime between:',
  fxHammerMaintenance: 'Service downtime',
  fxHammerExchangeAvalaiableIn: 'Service will be back online in:',

  // SymbolDetails tabs
  symbolDetailsTabOverview: 'Профил',
  symbolDetailsTabNews: 'Новини',
  symbolDetailsTabFinancials: 'Отчети',
  symbolDetailsTabRatios: 'Коефициенти',

  financialsIncomeStatement: 'Приходи и разходи',
  financialsBalanceSheet: 'Баланс',
  financialsCashFlow: 'Парични потоци',

  financialsQuarterlyOption: 'Тримесечие',
  financialsAnnualOption: 'Година',

  financialsRevenue: 'Revenue',
  financialsNetIncome: 'Net Income',
  financialsTotalAssets: 'Total Assets',
  financialsTotalLiabilities: 'Total Liabilities',
  financialsOperating: 'Operating',
  financialsInvesting: 'Investing',
  financialsFinancing: 'Financing',
  financialsName: 'Name',

  financialsCurrentAssets: 'Current Assets',
  financialsCashAndShorttermInvestments: 'Cash & Short-Term Investments',
  financialsShortTermInvestments: 'Short-Term Investments',
  financialsReceivables: 'Receivables',
  financialsInventory: 'Inventory',
  financialsOtherCurrentAssets: 'Other Current Assets',
  financialsLongTermAssets: 'Long-Term Assets',
  financialsPropertyPlantEquipment: 'Property, Plant & Equipment Net',
  financialsLongTermInvestments: 'Long-term Investments',
  financialsGoodwillAndIntangibles: 'Goodwill & Intangibles',
  financialsGoodwill: 'Goodwill',
  financialsIntangibleAssets: 'Intangible Assets',
  financialsTaxAssets: 'Tax Assets',
  financialsOtherLongTermAssets: 'Other Long-Term assets',
  financialsOtherAssets: 'Other Assets',
  financialsCashAndEquivalents: 'Cash & Equivalents',

  financialsCurrentLiabilities: 'Current Liabilities',
  financialsAccountsPayable: 'Accounts Payable',
  financialsShortTermDebt: 'Short-term Debt',
  financialsTaxPayables: 'Tax Payables',
  financialsDeferredRevenue: 'Deferred Revenue',
  financialsOtherCurrentLiabilities: 'Other Current Liabilities',
  financialsLongTermLiabilities: 'Long-term Liabilities',
  financialsLongTermDebt: 'Long-term Debt',
  financialsDeferredTaxLiabilities: 'Deferred Tax Liabilities',
  financialsOtherNonCurrentLiabilities: 'Other Non-current Liabilities',
  financialsOtherLiabilities: 'Other Liabilities',

  financialsTotalEquity: 'Total Equity',
  financialsCommonStock: 'Common Stock',
  financialsPreferredStock: 'Preferred Stock',
  financialsRetainedEarnings: 'Retained Earnings',
  financialsAccumulatedIncomeLoss: 'Accumulated Other Comprehensive Income/Loss',
  financialsOtherStockholdersEquity: 'Other Stockholders Equity',

  financialsTotalLiabilitiesAndStockholdersEquity: 'Total Liabilities & Stockholders Equity',
  financialsTotalInvestments: 'Total Investments',
  financialsTotalDebt: 'Total Debt',
  financialsTotalNet: 'Total Net',

  financialsCostOfRevenue: 'Cost of Revenue',
  financialsGrossProfit: 'Gross Profit',
  financialsOperatingExpenses: 'Operating Expenses',
  financialsResearchAndDevelopment: 'Research & Development',
  financialsSellingGeneralAndAdmin: 'Selling, General & Administrative',

  financialsOperatingIncome: 'Operating Income',
  financialsTotalOtherIncomeExpense: 'Total Other Income Expense',

  financialsIncomeBeforeTax: 'Income Before Tax',
  financialsIncomeTaxExpense: 'Income Tax Expense',
  financialsBasicEPS: 'Basic EPS',
  financialsDilutedEPS: 'Diluted EPS',
  financialsWeightedAverageShares: 'Weighted Average Shares',
  financialsDilutedWeightedAverageShares: 'Diluted Weighted Average Shares',
  financialsInterestIncome: 'Interest Income',
  financialsInterestExpense: 'Interest Expense',
  financialsEBITDA: 'EBITDA',

  financialsOperatingCashFlow: 'Operating Cash Flow',
  financialsDeprecationAndAmortization: 'Depreciation & Amortization',
  financialsDeferredIncomeTax: 'Deferred Income Tax',
  financialsStockBasedCompensation: 'Stock Based Compensation',
  financialsChangeInWorkingCapital: 'Change in Working Capital',
  financialsChangeInAccountsReceivable: 'Change in Accounts Receivable',
  financialsChangeInInventory: 'Change in Inventory',
  financialsChangeInAccountsPayables: 'Change in Accounts Payables',
  financialsOtherWorkingCapital: 'Other Working Capital',
  financialsOtherNonCashItems: 'Other NonCash Items',
  financialsInvestingCashFlow: 'Investing Cash Flow',
  financialsPPEInvestments: 'Investments in PPE',
  financialsAcquisitionsNet: 'Acquisitions Net',
  financialsSaleOfInvestments: 'Sale of Investments',
  financialsPurchaseOfInvestments: 'Purchase of Investments',
  financialsInvestingOther: 'Other Investing Activities',
  financialsFinancingCashFlow: 'Financing Cash Flow',
  financialsDebtRepayment: 'Debt Repayment',
  financialsCommonStockRepurchased: 'Common Stock Repurchased',
  financialsDividendsPaid: 'Dividends Paid',
  financialsFinancingOther: 'Other Financing Activities',
  financialsEndCashPosition: 'End Cash Position',
  financialsChangesInCash: 'Changes in Cash',
  financialsBeginningCashPosition: 'Beginning Cash Position',
  financialsCapitalExpenditure: 'Capital Expenditure',
  financialsFreeCashFlow: 'Free Cash Flow',

  // my-portal internal transfer
  internalTransferSuccessModalText: 'Успешно прехвърлихте €@@1 във вашата сметка за търговия!',

  // Ratios tab
  ratiosCompany: 'Компания',
  ratiosSector: 'Сектор',
  ratiosTTM: 'TTM',
  ratiosShowMoreButton: 'Покажи повече',
  ratiosShowLessButton: 'Покажи по-малко',
  ratiosModalSelectYear: 'Изберете година',
  ratiosModalSelectQuarter: 'Изберете тримесечие',
  ratiosModalSelectPeriod: 'Изберете период',

  // Ratios Profitability
  ratiosProfitability: 'Доходност',
  ratiosGrossMargin: 'Gross Margin',
  ratiosOperatingMargin: 'Operating Margin',
  ratiosNetProfitMargin: 'Net Profit Margin',
  ratiosNetIncome: 'Net Income Per Share',
  ratiosFreeCashFlow: 'Free Cash Flow Per Share',
  ratiosBookValuePerShare: 'Book Value Per Share',
  ratiosReturnOnAssets: 'Return on Asset (ROA)',
  ratiosReturnOnEquity: 'Return on Equity (ROE)',
  ratiosReturnOnInvestedCapital: 'Return on Invested Capital (ROIC)',
  ratiosDividendPayoutRatio: 'Dividend Payout Ratio',
  ratiosDividendYield: 'Dividend Yield',
  ratiosEarningsPerShare: 'Earnings Per Share (EPS)',

  // Liquidity & Solvency
  ratiosLiquidityAndSolvency: 'Ликвидност и платежоспособност',
  ratiosCurrentRatio: 'Current Ratio',
  ratiosQuickRatio: 'Quick Ratio',
  ratiosCashRatio: 'Cash Ratio',
  ratiosDaysOfSales: 'Days of Sales Outstanding',
  ratiosDeptToEquity: 'Dept to Equity',
  ratiosInterestCoverageRatio: 'Interest Coverage Ratio',
  ratiosCashFlowToDebtRatio: 'Cash Flow to Debt Ratio',

  // Valuation
  ratiosValuation: 'Оценка',
  ratiosPriceToBookRatio: 'Price to Book Ratio',
  ratiosPriceToSalesRatio: 'Price to Sales Ratio',
  ratiosPriceToEarningsRatio: 'Price to Earnings Ratio',
  ratiosPriceToFreeCashFlowRatio: 'Price to Free Cash Flow Ratio',
  ratiosEnterpriseValueToEbitda: 'Enterprise Value to EBITDA',
  ratiosEvToFreeCashFlow: 'EV to Free Cash Flow',
  ratiosPriceEarningsratio: 'Price Earnings to Growth Ratio (PEG)',

  // Capital Username enroll:
  userNameTitle: 'Потребителско име',
  userNameEdit: 'Редактирайте потребителското име',
  userNameDescription: 'Въведете потребителско име, с което да се представите пред останалите участници в играта.',
  userNameExist: 'Това потребителско име вече съществува',
};
